/**
 * Copyright IBM Corp. 2016, 2021
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import { i as iconPropTypes, _ as _objectWithoutProperties, I as Icon, a as _objectSpread2 } from '../iconPropTypes-44033017.js';
import React from 'react';
import '@carbon/icon-helpers';
import 'prop-types';

var _switch, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _circle, _path23, _circle2, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _circle3, _path106, _path107, _path108, _circle4, _path109, _path110, _path111, _circle5, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _circle6, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _circle7, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _circle8, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _circle9, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198;

var _excluded = ["children", "size"],
    _excluded2 = ["children", "size"],
    _excluded3 = ["children", "size"],
    _excluded4 = ["children", "size"],
    _excluded5 = ["children", "size"],
    _excluded6 = ["children", "size"],
    _excluded7 = ["children", "size"],
    _excluded8 = ["children", "size"],
    _excluded9 = ["children", "size"],
    _excluded10 = ["children", "size"],
    _excluded11 = ["children", "size"],
    _excluded12 = ["children", "size"],
    _excluded13 = ["children", "size"],
    _excluded14 = ["children", "size"],
    _excluded15 = ["children", "size"],
    _excluded16 = ["children", "size"],
    _excluded17 = ["children", "size"],
    _excluded18 = ["children", "size"],
    _excluded19 = ["children", "size"],
    _excluded20 = ["children", "size"],
    _excluded21 = ["children", "size"],
    _excluded22 = ["children", "size"],
    _excluded23 = ["children", "size"],
    _excluded24 = ["children", "size"],
    _excluded25 = ["children", "size"],
    _excluded26 = ["children", "size"],
    _excluded27 = ["children", "size"],
    _excluded28 = ["children", "size"],
    _excluded29 = ["children", "size"],
    _excluded30 = ["children", "size"],
    _excluded31 = ["children", "size"],
    _excluded32 = ["children", "size"],
    _excluded33 = ["children", "size"],
    _excluded34 = ["children", "size"],
    _excluded35 = ["children", "size"],
    _excluded36 = ["children", "size"],
    _excluded37 = ["children", "size"],
    _excluded38 = ["children", "size"],
    _excluded39 = ["children", "size"],
    _excluded40 = ["children", "size"],
    _excluded41 = ["children", "size"],
    _excluded42 = ["children", "size"],
    _excluded43 = ["children", "size"],
    _excluded44 = ["children", "size"],
    _excluded45 = ["children", "size"],
    _excluded46 = ["children", "size"],
    _excluded47 = ["children", "size"],
    _excluded48 = ["children", "size"],
    _excluded49 = ["children", "size"],
    _excluded50 = ["children", "size"],
    _excluded51 = ["children", "size"],
    _excluded52 = ["children", "size"],
    _excluded53 = ["children", "size"],
    _excluded54 = ["children", "size"],
    _excluded55 = ["children", "size"],
    _excluded56 = ["children", "size"],
    _excluded57 = ["children", "size"],
    _excluded58 = ["children", "size"],
    _excluded59 = ["children", "size"],
    _excluded60 = ["children", "size"],
    _excluded61 = ["children", "size"],
    _excluded62 = ["children", "size"],
    _excluded63 = ["children", "size"],
    _excluded64 = ["children", "size"],
    _excluded65 = ["children", "size"],
    _excluded66 = ["children", "size"],
    _excluded67 = ["children", "size"],
    _excluded68 = ["children", "size"],
    _excluded69 = ["children", "size"],
    _excluded70 = ["children", "size"],
    _excluded71 = ["children", "size"],
    _excluded72 = ["children", "size"],
    _excluded73 = ["children", "size"],
    _excluded74 = ["children", "size"],
    _excluded75 = ["children", "size"],
    _excluded76 = ["children", "size"],
    _excluded77 = ["children", "size"],
    _excluded78 = ["children", "size"],
    _excluded79 = ["children", "size"],
    _excluded80 = ["children", "size"],
    _excluded81 = ["children", "size"],
    _excluded82 = ["children", "size"],
    _excluded83 = ["children", "size"],
    _excluded84 = ["children", "size"],
    _excluded85 = ["children", "size"],
    _excluded86 = ["children", "size"],
    _excluded87 = ["children", "size"],
    _excluded88 = ["children", "size"],
    _excluded89 = ["children", "size"],
    _excluded90 = ["children", "size"],
    _excluded91 = ["children", "size"],
    _excluded92 = ["children", "size"],
    _excluded93 = ["children", "size"],
    _excluded94 = ["children", "size"],
    _excluded95 = ["children", "size"],
    _excluded96 = ["children", "size"],
    _excluded97 = ["children", "size"],
    _excluded98 = ["children", "size"],
    _excluded99 = ["children", "size"],
    _excluded100 = ["children", "size"],
    _excluded101 = ["children", "size"],
    _excluded102 = ["children", "size"],
    _excluded103 = ["children", "size"],
    _excluded104 = ["children", "size"],
    _excluded105 = ["children", "size"],
    _excluded106 = ["children", "size"],
    _excluded107 = ["children", "size"],
    _excluded108 = ["children", "size"],
    _excluded109 = ["children", "size"],
    _excluded110 = ["children", "size"],
    _excluded111 = ["children", "size"],
    _excluded112 = ["children", "size"],
    _excluded113 = ["children", "size"],
    _excluded114 = ["children", "size"],
    _excluded115 = ["children", "size"],
    _excluded116 = ["children", "size"],
    _excluded117 = ["children", "size"],
    _excluded118 = ["children", "size"],
    _excluded119 = ["children", "size"],
    _excluded120 = ["children", "size"],
    _excluded121 = ["children", "size"],
    _excluded122 = ["children", "size"],
    _excluded123 = ["children", "size"],
    _excluded124 = ["children", "size"],
    _excluded125 = ["children", "size"];
var DataQualityDefinition = /*#__PURE__*/React.forwardRef(function DataQualityDefinition(_ref, ref) {
  var children = _ref.children,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 16 : _ref$size,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.6 24.4L27.2 27 27.2 27 24.6 29.6 26 31 30 27 26 23zM22.4 24.4L19.8 27 19.8 27 22.4 29.6 21 31 17 27 21 23z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "8",
    r: "1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "16",
    r: "1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "24",
    r: "1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,3H8C6.9,3,6,3.9,6,5v22c0,1.1,0.9,2,2,2h7v-2H8v-6h18V5C26,3.9,25.1,3,24,3z M24,19H8v-6h16V19z M24,11H8V5h16V11z"
  })))), children);
});

if (process.env.NODE_ENV !== "production") {
  DataQualityDefinition.propTypes = iconPropTypes;
}
var DataRefinery = /*#__PURE__*/React.forwardRef(function DataRefinery(_ref2, ref) {
  var children = _ref2.children,
      _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? 16 : _ref2$size,
      rest = _objectWithoutProperties(_ref2, _excluded2);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7,30a5,5,0,1,1,5-5A5.0059,5.0059,0,0,1,7,30Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,7,22Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24,26H14V24H24V17H8a2.0021,2.0021,0,0,1-2-2V8A2.0021,2.0021,0,0,1,8,6H18V8H8v7H24a2.0021,2.0021,0,0,1,2,2v7A2.0021,2.0021,0,0,1,24,26Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28,12H22a2.0023,2.0023,0,0,1-2-2V4a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2v6A2.0023,2.0023,0,0,1,28,12ZM22,4v6h6V4Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DataRefinery.propTypes = iconPropTypes;
}
var DataRefineryReference = /*#__PURE__*/React.forwardRef(function DataRefineryReference(_ref3, ref) {
  var children = _ref3.children,
      _ref3$size = _ref3.size,
      size = _ref3$size === void 0 ? 16 : _ref3$size,
      rest = _objectWithoutProperties(_ref3, _excluded3);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM28 12H22a2.0023 2.0023 0 01-2-2V4a2.0023 2.0023 0 012-2h6a2.0023 2.0023 0 012 2v6A2.0023 2.0023 0 0128 12zM22 4v6h6V4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24,26H16V24h8V17H8a2.0021,2.0021,0,0,1-2-2V8A2.0021,2.0021,0,0,1,8,6H18V8H8v7H24a2.0021,2.0021,0,0,1,2,2v7A2.0021,2.0021,0,0,1,24,26Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DataRefineryReference.propTypes = iconPropTypes;
}
var DataShare = /*#__PURE__*/React.forwardRef(function DataShare(_ref4, ref) {
  var children = _ref4.children,
      _ref4$size = _ref4.size,
      size = _ref4$size === void 0 ? 16 : _ref4$size,
      rest = _objectWithoutProperties(_ref4, _excluded4);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5 25V15.8281l-3.5859 3.586L0 18l6-6 6 6-1.4141 1.4141L7 15.8281V25H19v2H7A2.0024 2.0024 0 015 25zM24 22h4a2.002 2.002 0 012 2v4a2.002 2.002 0 01-2 2H24a2.002 2.002 0 01-2-2V24A2.002 2.002 0 0124 22zm4 6V24H23.9985L24 28zM27 6v9.1719l3.5859-3.586L32 13l-6 6-6-6 1.4141-1.4141L25 15.1719V6H13V4H25A2.0024 2.0024 0 0127 6zM2 6H8V8H2zM2 2H10V4H2z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DataShare.propTypes = iconPropTypes;
}
var DataTable = /*#__PURE__*/React.forwardRef(function DataTable(_ref5, ref) {
  var children = _ref5.children,
      _ref5$size = _ref5.size,
      size = _ref5$size === void 0 ? 16 : _ref5$size,
      rest = _objectWithoutProperties(_ref5, _excluded5);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8 18H12V20H8zM14 18H18V20H14zM8 14H12V16H8zM14 22H18V24H14zM20 14H24V16H20zM20 22H24V24H20z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27,3H5A2.0025,2.0025,0,0,0,3,5V27a2.0025,2.0025,0,0,0,2,2H27a2.0025,2.0025,0,0,0,2-2V5A2.0025,2.0025,0,0,0,27,3Zm0,2,0,4H5V5ZM5,27V11H27l0,16Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DataTable.propTypes = iconPropTypes;
}
var DataTableReference = /*#__PURE__*/React.forwardRef(function DataTableReference(_ref6, ref) {
  var children = _ref6.children,
      _ref6$size = _ref6.size,
      size = _ref6$size === void 0 ? 16 : _ref6$size,
      rest = _objectWithoutProperties(_ref6, _excluded6);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM20 22H24V24H20zM16 18H20V20H16zM20 14H24V16H20zM8 14H12V16H8z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27,3H5A2.0027,2.0027,0,0,0,3,5V16H5V11H27V27H16v2H27a2.0027,2.0027,0,0,0,2-2V5A2.0027,2.0027,0,0,0,27,3Zm0,6H5V5H27Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DataTableReference.propTypes = iconPropTypes;
}
var DataVis_1 = /*#__PURE__*/React.forwardRef(function DataVis_1(_ref7, ref) {
  var children = _ref7.children,
      _ref7$size = _ref7.size,
      size = _ref7$size === void 0 ? 16 : _ref7$size,
      rest = _objectWithoutProperties(_ref7, _excluded7);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26,22a3.9553,3.9553,0,0,0-2.0193.5667L20.167,18.7529a4.9654,4.9654,0,0,0,0-5.5058L22.714,10.7A3.0284,3.0284,0,1,0,21.3,9.286l-2.547,2.547a4.9654,4.9654,0,0,0-5.5058,0L9.4332,8.0191A3.9553,3.9553,0,0,0,10,6a4,4,0,1,0-4,4,3.9553,3.9553,0,0,0,2.0191-.5668l3.8139,3.8139a4.9654,4.9654,0,0,0,0,5.5058L8.0192,22.5668A3.9556,3.9556,0,0,0,6,22a4,4,0,1,0,4,4,3.9553,3.9553,0,0,0-.5667-2.0192l3.8138-3.8138A4.9686,4.9686,0,0,0,15,20.8989v3.2848a3,3,0,1,0,2,0V20.8989a4.9686,4.9686,0,0,0,1.7529-.7319l3.8138,3.8137A3.9553,3.9553,0,0,0,22,26a4,4,0,1,0,4-4ZM16,13a3,3,0,1,1-3,3A3.0033,3.0033,0,0,1,16,13ZM4,6A2,2,0,1,1,6,8,2.002,2.002,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Zm20,0a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,26,28Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DataVis_1.propTypes = iconPropTypes;
}
var DataVis_2 = /*#__PURE__*/React.forwardRef(function DataVis_2(_ref8, ref) {
  var children = _ref8.children,
      _ref8$size = _ref8.size,
      size = _ref8$size === void 0 ? 16 : _ref8$size,
      rest = _objectWithoutProperties(_ref8, _excluded8);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H17a2.002,2.002,0,0,0-2,2v6H4a2.002,2.002,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H15a2.0023,2.0023,0,0,0,2-2V22H28a2.0027,2.0027,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2Zm0,2,0,4H17V4ZM15.0009,22H4V18H15ZM17,10H28.0007l.0005,4H17Zm-2,2v4H4V12ZM4,28V24H15.0011l0,4Zm13-8V16H28.0015l0,4Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DataVis_2.propTypes = iconPropTypes;
}
var DataVis_3 = /*#__PURE__*/React.forwardRef(function DataVis_3(_ref9, ref) {
  var children = _ref9.children,
      _ref9$size = _ref9.size,
      size = _ref9$size === void 0 ? 16 : _ref9$size,
      rest = _objectWithoutProperties(_ref9, _excluded9);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28,3a2.9913,2.9913,0,0,0-2.8163,2H21.858a3.9807,3.9807,0,0,0-7.716,0H9.858A3.9916,3.9916,0,1,0,5,9.858v4.284a3.9807,3.9807,0,0,0,0,7.716v3.3257a3,3,0,1,0,2,0V21.858a3.978,3.978,0,0,0,1.6729-.9034l3.3638,1.6819A2.9635,2.9635,0,0,0,12,23a3.0117,3.0117,0,1,0,.9221-2.1572L9.7744,19.269A3.95,3.95,0,0,0,10,18a3.9963,3.9963,0,0,0-3-3.858V9.858A3.9947,3.9947,0,0,0,9.858,7h4.284a3.9366,3.9366,0,0,0,4.7816,2.8818l1.8118,3.1705a3.0451,3.0451,0,1,0,1.7326-.9987L20.6893,8.941A3.9839,3.9839,0,0,0,21.858,7h3.3257A2.995,2.995,0,1,0,28,3ZM8,18a2,2,0,1,1-2-2A2.0023,2.0023,0,0,1,8,18ZM6,8A2,2,0,1,1,8,6,2.002,2.002,0,0,1,6,8ZM16,6a2,2,0,1,1,2,2A2.002,2.002,0,0,1,16,6Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DataVis_3.propTypes = iconPropTypes;
}
var DataVis_4 = /*#__PURE__*/React.forwardRef(function DataVis_4(_ref10, ref) {
  var children = _ref10.children,
      _ref10$size = _ref10.size,
      size = _ref10$size === void 0 ? 16 : _ref10$size,
      rest = _objectWithoutProperties(_ref10, _excluded10);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M27,3H5A2.002,2.002,0,0,0,3,5V27a2.0023,2.0023,0,0,0,2,2H27a2.0027,2.0027,0,0,0,2-2V5A2.0023,2.0023,0,0,0,27,3Zm0,6H17V5H27ZM15,27H11V23h4Zm0-6H11V17h4ZM9,21H5V17H9Zm2-6V11H21v4Zm0-6V5h4V9Zm12,2h4l0,4H23ZM9,5V15H5V5ZM5,23H9v4H5Zm12,4V17H27.001l.001,10Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DataVis_4.propTypes = iconPropTypes;
}
var DatabaseDatastax = /*#__PURE__*/React.forwardRef(function DatabaseDatastax(_ref11, ref) {
  var children = _ref11.children,
      _ref11$size = _ref11.size,
      size = _ref11$size === void 0 ? 16 : _ref11$size,
      rest = _objectWithoutProperties(_ref11, _excluded11);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8684 22.0684l1.7937-1.7476A4.2184 4.2184 0 0023.95 21.9534c1.4026 0 2.0005-.5288 2.0005-1.38 0-.69-.4138-1.1267-1.4717-1.2646l-1.1958-.1612c-2.5754-.3217-4.0009-1.4484-4.0009-3.633 0-2.3225 1.8166-3.7942 4.5529-3.7942a5.7221 5.7221 0 014.691 1.8855l-1.7246 1.7246a3.9649 3.9649 0 00-2.8743-1.2876c-1.2649 0-1.8167.5059-1.8167 1.2417 0 .8049.4368 1.1726 1.5638 1.3567l1.2187.1609c2.6213.3679 3.886 1.5408 3.886 3.5412 0 2.3226-1.9546 3.9322-4.9439 3.9322A6.0942 6.0942 0 0118.8684 22.0684zM4.24 7.95h5.8409c4.185 0 6.9213 2.69 6.9213 8.0254S14.2661 24 10.0811 24H4.24zm5.8409 13.36c2.2534 0 3.7021-1.3338 3.7021-4.07V14.71c0-2.7364-1.4487-4.07-3.7021-4.07H7.2756V21.31z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DatabaseDatastax.propTypes = iconPropTypes;
}
var DatabaseElastic = /*#__PURE__*/React.forwardRef(function DatabaseElastic(_ref12, ref) {
  var children = _ref12.children,
      _ref12$size = _ref12.size,
      size = _ref12$size === void 0 ? 16 : _ref12$size,
      rest = _objectWithoutProperties(_ref12, _excluded12);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8281 22.0684l1.7937-1.7476A4.2185 4.2185 0 0022.91 21.9534c1.4025 0 2-.5288 2-1.38 0-.69-.4138-1.1267-1.4716-1.2646l-1.1958-.1612c-2.5755-.3217-4.001-1.4484-4.001-3.633 0-2.3225 1.8166-3.7942 4.553-3.7942a5.722 5.722 0 014.6909 1.8855l-1.7246 1.7246a3.9643 3.9643 0 00-2.8743-1.2876c-1.2649 0-1.8166.5059-1.8166 1.2417 0 .8049.4367 1.1726 1.5637 1.3567l1.2187.1609c2.6214.3679 3.886 1.5408 3.886 3.5413 0 2.3225-1.9546 3.9321-4.9438 3.9321A6.0944 6.0944 0 0117.8281 22.0684zM5.2471 24V7.95H15.825v2.69H8.2825v3.8862h6.6687v2.6905H8.2825V21.31H15.825V24z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DatabaseElastic.propTypes = iconPropTypes;
}
var DatabaseEnterpriseDb2 = /*#__PURE__*/React.forwardRef(function DatabaseEnterpriseDb2(_ref13, ref) {
  var children = _ref13.children,
      _ref13$size = _ref13.size,
      size = _ref13$size === void 0 ? 16 : _ref13$size,
      rest = _objectWithoutProperties(_ref13, _excluded13);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M17.84 24V11.9966H20.783v2h.1149a3.3115 3.3115 0 013.3572-2.2764c2.46 0 3.84 1.7017 3.84 4.6909V24H25.1519V16.7107c0-1.7017-.5748-2.5754-1.9776-2.5754-1.2187 0-2.3913.6438-2.3913 1.9314V24zM4.2236 24V7.95H14.8015v2.69H7.259v3.8862h6.6687v2.6905H7.259V21.31h7.5425V24z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DatabaseEnterpriseDb2.propTypes = iconPropTypes;
}
var DatabaseEtcd = /*#__PURE__*/React.forwardRef(function DatabaseEtcd(_ref14, ref) {
  var children = _ref14.children,
      _ref14$size = _ref14.size,
      size = _ref14$size === void 0 ? 16 : _ref14$size,
      rest = _objectWithoutProperties(_ref14, _excluded14);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9443 20.9417v-6.6h-1.77V11.9966h.92c.8735 0 1.1494-.4138 1.1494-1.2417V8.7083h2.6445v3.2883h2.46V14.342h-2.46v7.3125h2.2764V24H24.0488A2.778 2.778 0 0120.9443 20.9417zM6.6846 24V7.95H17.2627v2.69H9.72v3.8862h6.669v2.6905H9.72V21.31h7.543V24z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DatabaseEtcd.propTypes = iconPropTypes;
}
var DatabaseMongodb = /*#__PURE__*/React.forwardRef(function DatabaseMongodb(_ref15, ref) {
  var children = _ref15.children,
      _ref15$size = _ref15.size,
      size = _ref15$size === void 0 ? 16 : _ref15$size,
      rest = _objectWithoutProperties(_ref15, _excluded15);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3481 28.875c-4.0473 0-5.5878-1.0579-5.5878-2.8284a2.2115 2.2115 0 012.1386-2.3v-.253a1.9726 1.9726 0 01-1.5405-2c0-1.242 1.0576-1.8628 2.207-2.1158v-.0918a3.6228 3.6228 0 01-2.1845-3.4953c0-2.4375 1.7246-4.07 4.9672-4.07A6.6717 6.6717 0 0127.44 12.02v-.3908a1.5343 1.5343 0 011.7022-1.7476h1.8623v2.2534H28.4521v.322a3.5917 3.5917 0 011.8628 3.3343c0 2.4145-1.7016 4.0241-4.9668 4.0241a7.3662 7.3662 0 01-1.8393-.207 1.23 1.23 0 00-.8511 1.0808c0 .5979.5059.8967 1.564.8967H27.44c2.9434 0 4.208 1.2649 4.208 3.4263C31.6484 27.5183 29.9473 28.875 25.3481 28.875zm1.4947-4.7371H22.75a1.473 1.473 0 00-.6211 1.2417c0 .92.6895 1.4717 2.5293 1.4717H26.13c1.9087 0 2.76-.4829 2.76-1.4946C28.89 24.5979 28.3374 24.1379 26.8428 24.1379zm.667-8.163v-.3912c0-1.2187-.7588-1.84-2.1617-1.84s-2.1616.6209-2.1616 1.84v.3912c0 1.1955.7588 1.84 2.1616 1.84S27.51 17.17 27.51 15.9749zM2.2344 7.95H5.66l4.1162 7.8413h.0923l4.07-7.8413h3.2886V24H14.3525V12.48h-.0918L13.0186 15.032l-3.2881 6.07-3.2881-6.07L5.2007 12.48H5.1084V24H2.2344z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DatabaseMongodb.propTypes = iconPropTypes;
}
var DatabasePostgreSql = /*#__PURE__*/React.forwardRef(function DatabasePostgreSql(_ref16, ref) {
  var children = _ref16.children,
      _ref16$size = _ref16.size,
      size = _ref16$size === void 0 ? 16 : _ref16$size,
      rest = _objectWithoutProperties(_ref16, _excluded16);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M22.98 28.875c-4.0474 0-5.5879-1.0579-5.5879-2.8284a2.2112 2.2112 0 012.1387-2.3v-.253a1.9725 1.9725 0 01-1.541-2c0-1.242 1.0576-1.8628 2.2075-2.1158v-.0918a3.622 3.622 0 01-2.1846-3.4953c0-2.4375 1.7246-4.07 4.9673-4.07a6.6768 6.6768 0 012.0923.2988v-.3908a1.5341 1.5341 0 011.7016-1.7476h1.8623v2.2534H26.0835v.322a3.5926 3.5926 0 011.8628 3.3343c0 2.4145-1.7022 4.0241-4.9668 4.0241a7.3717 7.3717 0 01-1.84-.207 1.23 1.23 0 00-.8505 1.0808c0 .5979.5058.8967 1.5634.8967h3.2193c2.9433 0 4.208 1.2649 4.208 3.4263C29.28 27.5183 27.5781 28.875 22.98 28.875zm1.4941-4.7371H20.3809A1.474 1.474 0 0019.76 25.38c0 .92.69 1.4717 2.5293 1.4717h1.4716c1.9092 0 2.76-.4829 2.76-1.4946C26.5205 24.5979 25.9688 24.1379 24.4736 24.1379zm.667-8.163v-.3912c0-1.2187-.7588-1.84-2.1611-1.84s-2.1621.6209-2.1621 1.84v.3912c0 1.1955.7588 1.84 2.1621 1.84S25.1406 17.17 25.1406 15.9749zM4.603 24V7.95h7.22c2.9668 0 4.76 2 4.76 4.967 0 2.9893-1.7935 4.9668-4.76 4.9668H7.6387V24zm3.0357-8.738h3.9092a1.6886 1.6886 0 001.8852-1.8167V12.3875a1.672 1.672 0 00-1.8852-1.7935H7.6387z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DatabasePostgreSql.propTypes = iconPropTypes;
}
var DatabaseRabbit = /*#__PURE__*/React.forwardRef(function DatabaseRabbit(_ref17, ref) {
  var children = _ref17.children,
      _ref17$size = _ref17.size,
      size = _ref17$size === void 0 ? 16 : _ref17$size,
      rest = _objectWithoutProperties(_ref17, _excluded17);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9434 20.7346c0-2.46 1.8623-3.6792 5.1279-3.6792h2.0464v-.8738c0-1.3337-.6665-2.1154-2.23-2.1154a3.1249 3.1249 0 00-2.7363 1.5175L18.4033 14.02a5.0544 5.0544 0 014.6909-2.3c3.2422 0 4.9668 1.54 4.9668 4.2771v5.6567h1.1958V24H27.624a2.184 2.184 0 01-2.23-2.07h-.1377c-.3912 1.5408-1.7017 2.3455-3.4952 2.3455C19.3232 24.2759 17.9434 22.8733 17.9434 20.7346zm7.1743-.3218V18.8262H23.2324c-1.541 0-2.3.5288-2.3 1.4717v.3908c0 .9658.667 1.4488 1.8164 1.4488C24.06 22.1375 25.1177 21.54 25.1177 20.4128zM6.9717 24H3.9365V7.95H11.18c2.92 0 4.7373 1.9316 4.7373 4.967a4.4237 4.4237 0 01-2.9893 4.553L16.2158 24h-3.38L9.8462 17.8145H6.9717zm3.9092-8.738a1.689 1.689 0 001.8857-1.8167V12.3875a1.6723 1.6723 0 00-1.8857-1.7935H6.9717v4.668z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DatabaseRabbit.propTypes = iconPropTypes;
}
var DatabaseRedis = /*#__PURE__*/React.forwardRef(function DatabaseRedis(_ref18, ref) {
  var children = _ref18.children,
      _ref18$size = _ref18.size,
      size = _ref18$size === void 0 ? 16 : _ref18$size,
      rest = _objectWithoutProperties(_ref18, _excluded18);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7156 22h-.115a3.371 3.371 0 01-3.3113 2.2764c-3.0124 0-4.6912-2.2764-4.6912-6.3006 0-4.0012 1.6788-6.2546 4.6912-6.2546a3.3049 3.3049 0 013.3113 2.2534h.115v-6.99h2.9433V24H25.7156zm0-2.1157V16.0667c0-1.1727-1.0808-1.9314-2.4837-1.9314A2.556 2.556 0 0020.68 16.9636v2.07a2.5365 2.5365 0 002.5522 2.8052C24.6348 21.8384 25.7156 21.1257 25.7156 19.8838zM6.5576 24H3.5222V7.95h7.2434c2.92 0 4.7371 1.9316 4.7371 4.967a4.4237 4.4237 0 01-2.9893 4.553L15.8018 24h-3.38L9.4321 17.8145H6.5576zm3.9092-8.738a1.6888 1.6888 0 001.8855-1.8167V12.3875a1.6722 1.6722 0 00-1.8855-1.7935H6.5576v4.668z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DatabaseRedis.propTypes = iconPropTypes;
}
var Datastore = /*#__PURE__*/React.forwardRef(function Datastore(_ref19, ref) {
  var children = _ref19.children,
      _ref19$size = _ref19.size,
      size = _ref19$size === void 0 ? 16 : _ref19$size,
      rest = _objectWithoutProperties(_ref19, _excluded19);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "23",
    r: "1"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M8 22H20V24H8z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "9",
    r: "1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8H20V10H8z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M26,14a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2H6A2,2,0,0,0,4,6v6a2,2,0,0,0,2,2H8v4H6a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V20a2,2,0,0,0-2-2H24V14ZM6,6H26v6H6ZM26,26H6V20H26Zm-4-8H10V14H22Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Datastore.propTypes = iconPropTypes;
}
var Debug = /*#__PURE__*/React.forwardRef(function Debug(_ref20, ref) {
  var children = _ref20.children,
      _ref20$size = _ref20.size,
      size = _ref20$size === void 0 ? 16 : _ref20$size,
      rest = _objectWithoutProperties(_ref20, _excluded20);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M29.83,20l.34-2L25,17.15V13c0-.08,0-.15,0-.23l5.06-1.36-.51-1.93-4.83,1.29A9,9,0,0,0,20,5V2H18V4.23a8.81,8.81,0,0,0-4,0V2H12V5a9,9,0,0,0-4.71,5.82L2.46,9.48,2,11.41,7,12.77c0,.08,0,.15,0,.23v4.15L1.84,18l.32,2L7,19.18a8.9,8.9,0,0,0,.82,3.57L3.29,27.29l1.42,1.42,4.19-4.2a9,9,0,0,0,14.2,0l4.19,4.2,1.42-1.42-4.54-4.54A8.9,8.9,0,0,0,25,19.18ZM15,25.92A7,7,0,0,1,9,19V13h6ZM9.29,11a7,7,0,0,1,13.42,0ZM23,19a7,7,0,0,1-6,6.92V13h6Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Debug.propTypes = iconPropTypes;
}
var DecisionTree = /*#__PURE__*/React.forwardRef(function DecisionTree(_ref21, ref) {
  var children = _ref21.children,
      _ref21$size = _ref21.size,
      size = _ref21$size === void 0 ? 16 : _ref21$size,
      rest = _objectWithoutProperties(_ref21, _excluded21);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M30,12V4H22V7H18a2.0023,2.0023,0,0,0-2,2v6H10V12H2v8h8V17h6v6a2.0023,2.0023,0,0,0,2,2h4v3h8V20H22v3H18V9h4v3ZM8,18H4V14H8Zm16,4h4v4H24ZM24,6h4v4H24Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DecisionTree.propTypes = iconPropTypes;
}
var Delivery = /*#__PURE__*/React.forwardRef(function Delivery(_ref22, ref) {
  var children = _ref22.children,
      _ref22$size = _ref22.size,
      size = _ref22$size === void 0 ? 16 : _ref22$size,
      rest = _objectWithoutProperties(_ref22, _excluded22);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M4 16H16V18H4zM2 11H12V13H2z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9189,16.6064l-3-7A.9985.9985,0,0,0,26,9H23V7a1,1,0,0,0-1-1H6V8H21V20.5562A3.9924,3.9924,0,0,0,19.1421,23H12.8579a4,4,0,1,0,0,2h6.2842a3.9806,3.9806,0,0,0,7.7158,0H29a1,1,0,0,0,1-1V17A.9965.9965,0,0,0,29.9189,16.6064ZM9,26a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,9,26ZM23,11h2.3408l2.1431,5H23Zm0,15a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,23,26Zm5-3H26.8579A3.9954,3.9954,0,0,0,23,20V18h5Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Delivery.propTypes = iconPropTypes;
}
var DeliveryAdd = /*#__PURE__*/React.forwardRef(function DeliveryAdd(_ref23, ref) {
  var children = _ref23.children,
      _ref23$size = _ref23.size,
      size = _ref23$size === void 0 ? 16 : _ref23$size,
      rest = _objectWithoutProperties(_ref23, _excluded23);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6L8 6 8 2 6 2 6 6 2 6 2 8 6 8 6 12 8 12 8 8 12 8 12 6z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9189,16.6064l-3-7A.9985.9985,0,0,0,26,9H23V7a1,1,0,0,0-1-1H15V8h6V20.5562A3.9924,3.9924,0,0,0,19.1421,23H12.8579a3.9806,3.9806,0,0,0-7.7158,0H4V14H2V24a1,1,0,0,0,1,1H5.1421a3.9806,3.9806,0,0,0,7.7158,0h6.2842a3.9806,3.9806,0,0,0,7.7158,0H29a1,1,0,0,0,1-1V17A.9965.9965,0,0,0,29.9189,16.6064ZM9,26a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,9,26ZM23,11h2.3408l2.1431,5H23Zm0,15a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,23,26Zm5-3H26.8579A3.9954,3.9954,0,0,0,23,20V18h5Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DeliveryAdd.propTypes = iconPropTypes;
}
var DeliveryParcel = /*#__PURE__*/React.forwardRef(function DeliveryParcel(_ref24, ref) {
  var children = _ref24.children,
      _ref24$size = _ref24.size,
      size = _ref24$size === void 0 ? 16 : _ref24$size,
      rest = _objectWithoutProperties(_ref24, _excluded24);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4819,8.624l-10-5.5a1,1,0,0,0-.9638,0l-10,5.5a1,1,0,0,0,0,1.752L18,15.5913V26.3086l-3.0362-1.6693L14,26.3912l4.5181,2.4848a.9984.9984,0,0,0,.9638,0l10-5.5A1,1,0,0,0,30,22.5V9.5A1,1,0,0,0,29.4819,8.624ZM19,5.1416,26.9248,9.5,19,13.8584,11.0752,9.5Zm9,16.7671-8,4.4V15.5913l8-4.4Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M2 14H10V16H2z",
    transform: "rotate(-180 6 15)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M4 22H12V24H4z",
    transform: "rotate(-180 8 23)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M6 18H14V20H6z",
    transform: "rotate(-180 10 19)"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DeliveryParcel.propTypes = iconPropTypes;
}
var DeliveryTruck = /*#__PURE__*/React.forwardRef(function DeliveryTruck(_ref25, ref) {
  var children = _ref25.children,
      _ref25$size = _ref25.size,
      size = _ref25$size === void 0 ? 16 : _ref25$size,
      rest = _objectWithoutProperties(_ref25, _excluded25);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M29.92,16.61l-3-7A1,1,0,0,0,26,9H23V7a1,1,0,0,0-1-1H3A1,1,0,0,0,2,7V24a1,1,0,0,0,1,1H5.14a4,4,0,0,0,7.72,0h6.28a4,4,0,0,0,7.72,0H29a1,1,0,0,0,1-1V17A1,1,0,0,0,29.92,16.61ZM23,11h2.34l2.14,5H23ZM9,26a2,2,0,1,1,2-2A2,2,0,0,1,9,26Zm10.14-3H12.86a4,4,0,0,0-7.72,0H4V8H21V20.56A4,4,0,0,0,19.14,23ZM23,26a2,2,0,1,1,2-2A2,2,0,0,1,23,26Zm5-3H26.86A4,4,0,0,0,23,20V18h5Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DeliveryTruck.propTypes = iconPropTypes;
}
var WatsonHealthDenominate = /*#__PURE__*/React.forwardRef(function WatsonHealthDenominate(_ref26, ref) {
  var children = _ref26.children,
      _ref26$size = _ref26.size,
      size = _ref26$size === void 0 ? 16 : _ref26$size,
      rest = _objectWithoutProperties(_ref26, _excluded26);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M25 23H19a3 3 0 00-3 3v2h2V26a1 1 0 011-1h6a1 1 0 011 1v2h2V26A3 3 0 0025 23zM18 18a4 4 0 104-4A4 4 0 0018 18zm6 0a2 2 0 11-2-2A2 2 0 0124 18zM15 15.415L13.586 14 11 16.587 8.414 14 7 15.415 9.586 18 7 20.586 8.414 22 11 19.414 13.586 22 15 20.586 12.414 18 15 15.415z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M14,26H4V6h7.1716l3.4141,3.4143L15.1716,10H28v8h2V10a2,2,0,0,0-2-2H16L12.5859,4.5858A2,2,0,0,0,11.1716,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H14Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  WatsonHealthDenominate.propTypes = iconPropTypes;
}
var Departure = /*#__PURE__*/React.forwardRef(function Departure(_ref27, ref) {
  var children = _ref27.children,
      _ref27$size = _ref27.size,
      size = _ref27$size === void 0 ? 16 : _ref27$size,
      rest = _objectWithoutProperties(_ref27, _excluded27);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M2 28H30V30H2zM13.48 5.15l5.69 8.14.8 1.15 1.35-.36 4.52-1.21a2.13 2.13 0 011.12 0A1.84 1.84 0 0128.23 14 1.87 1.87 0 0127 16.45l-18.71 5a1.78 1.78 0 01-1 0A1.87 1.87 0 016 20.12l-.25-.93L5 16.38l-.74-2.74 1.44-.39L8 16.35l.81 1.08 1.31-.35 2.8-.75 1.94-.52-.52-1.93L12.08 5.52l1.4-.37M14.16 3a1.06 1.06 0 00-.5 0l-3.09.83A1 1 0 009.89 5l2.5 9.36-2.81.75L6.85 11.5a1 1 0 00-.52-.36 1.06 1.06 0 00-.5 0L2.72 12A1 1 0 002 13.16L3 16.9l.75 2.8.25.94a3.87 3.87 0 002.74 2.74 3.91 3.91 0 002 0l18.7-5a3.84 3.84 0 000-7.44 4.27 4.27 0 00-2.16 0l-4.51 1.21L14.7 3.41A1 1 0 0014.16 3z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Departure.propTypes = iconPropTypes;
}
var Deploy = /*#__PURE__*/React.forwardRef(function Deploy(_ref28, ref) {
  var children = _ref28.children,
      _ref28$size = _ref28.size,
      size = _ref28$size === void 0 ? 16 : _ref28$size,
      rest = _objectWithoutProperties(_ref28, _excluded28);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M23,2,17,8l1.4146,1.4023L22,5.8184V28H6V12H4V28a2.0025,2.0025,0,0,0,2,2H22a2.0025,2.0025,0,0,0,2-2V5.8154l3.5859,3.5869L29,8Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M16,24H12a2.0023,2.0023,0,0,1-2-2V18a2.0023,2.0023,0,0,1,2-2h4a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,16,24Zm-4-6v4h4V18Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Deploy.propTypes = iconPropTypes;
}
var DeployRules = /*#__PURE__*/React.forwardRef(function DeployRules(_ref29, ref) {
  var children = _ref29.children,
      _ref29$size = _ref29.size,
      size = _ref29$size === void 0 ? 16 : _ref29$size,
      rest = _objectWithoutProperties(_ref29, _excluded29);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M18 4L12 10 13.41 11.41 17 7.83 17 20 19 20 19 7.83 22.59 11.41 24 10 18 4zM8 18H15V20H8zM8 22H24V24H8zM8 26H24V28H8z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DeployRules.propTypes = iconPropTypes;
}
var DeploymentPattern = /*#__PURE__*/React.forwardRef(function DeploymentPattern(_ref30, ref) {
  var children = _ref30.children,
      _ref30$size = _ref30.size,
      size = _ref30$size === void 0 ? 16 : _ref30$size,
      rest = _objectWithoutProperties(_ref30, _excluded30);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M8 20H4.73A1.9735 1.9735 0 003 19a2 2 0 000 4A1.9735 1.9735 0 004.73 22H8zM29 9a1.9735 1.9735 0 00-1.73 1H24v2h3.27A1.9991 1.9991 0 1029 9z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4141 5L21 .5859 16.5859 5 20 8.4141V18h2V8.4141zM21 3.4141L22.5859 5 21 6.5859 19.4141 5zM12 23.5859V14H10v9.5859L6.5859 27 11 31.4141 15.4141 27zM9.4141 27L11 25.4141 12.5859 27 11 28.5859z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M18,10H8.4141L5,6.5859.5859,11,5,15.4141,8.4141,12H18ZM5,12.5859,3.4141,11,5,9.4141,6.5859,11Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M13 3A2 2 0 009 3 1.9733 1.9733 0 0010 4.73V8h2V4.73A1.9733 1.9733 0 0013 3zM22 27.2705V24H20v3.27a2 2 0 102 0z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4141,21,27,16.5859,23.5859,20H14v2h9.5859L27,25.4141ZM27,19.4141,28.5859,21,27,22.5859,25.4141,21Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DeploymentPattern.propTypes = iconPropTypes;
}
var DeploymentPolicy = /*#__PURE__*/React.forwardRef(function DeploymentPolicy(_ref31, ref) {
  var children = _ref31.children,
      _ref31$size = _ref31.size,
      size = _ref31$size === void 0 ? 16 : _ref31$size,
      rest = _objectWithoutProperties(_ref31, _excluded31);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M19 16L19 14 26.171 14 23.878 11.707 25.292 10.293 30 15 25.292 19.707 23.878 18.293 26.171 16 19 16zM17 12L15 12 15 5.828 12.707 8.121 11.293 6.707 16 2 20.707 6.707 19.293 8.121 17 5.828 17 12zM17 20.1011V18a4.0045 4.0045 0 00-4-4H5.8281l2.293-2.293L6.707 10.293 2 15l4.707 4.707 1.4141-1.414L5.8281 16H13a2.0025 2.0025 0 012 2v2.1011a5 5 0 102 0zM16 28a3 3 0 113-3A3.0033 3.0033 0 0116 28z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DeploymentPolicy.propTypes = iconPropTypes;
}
var DeploymentUnitData = /*#__PURE__*/React.forwardRef(function DeploymentUnitData(_ref32, ref) {
  var children = _ref32.children,
      _ref32$size = _ref32.size,
      size = _ref32$size === void 0 ? 16 : _ref32$size,
      rest = _objectWithoutProperties(_ref32, _excluded32);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M16,23H12V9h4a4.0045,4.0045,0,0,1,4,4v6A4.0042,4.0042,0,0,1,16,23Zm-2-2h2a2.0023,2.0023,0,0,0,2-2V13a2.002,2.002,0,0,0-2-2H14Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DeploymentUnitData.propTypes = iconPropTypes;
}
var DeploymentUnitExecution = /*#__PURE__*/React.forwardRef(function DeploymentUnitExecution(_ref33, ref) {
  var children = _ref33.children,
      _ref33$size = _ref33.size,
      size = _ref33$size === void 0 ? 16 : _ref33$size,
      rest = _objectWithoutProperties(_ref33, _excluded33);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11L20 9 12 9 12 23 20 23 20 21 14 21 14 17 19 17 19 15 14 15 14 11 20 11z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DeploymentUnitExecution.propTypes = iconPropTypes;
}
var DeploymentUnitInstallation = /*#__PURE__*/React.forwardRef(function DeploymentUnitInstallation(_ref34, ref) {
  var children = _ref34.children,
      _ref34$size = _ref34.size,
      size = _ref34$size === void 0 ? 16 : _ref34$size,
      rest = _objectWithoutProperties(_ref34, _excluded34);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11L15 11 15 21 12 21 12 23 20 23 20 21 17 21 17 11 20 11 20 9 12 9 12 11z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DeploymentUnitInstallation.propTypes = iconPropTypes;
}
var DeploymentUnitPresentation = /*#__PURE__*/React.forwardRef(function DeploymentUnitPresentation(_ref35, ref) {
  var children = _ref35.children,
      _ref35$size = _ref35.size,
      size = _ref35$size === void 0 ? 16 : _ref35$size,
      rest = _objectWithoutProperties(_ref35, _excluded35);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M14,23H12V9h6a2.002,2.002,0,0,1,2,2v5a2.002,2.002,0,0,1-2,2H14Zm0-7h4V11H14Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DeploymentUnitPresentation.propTypes = iconPropTypes;
}
var DeploymentUnitTechnicalData = /*#__PURE__*/React.forwardRef(function DeploymentUnitTechnicalData(_ref36, ref) {
  var children = _ref36.children,
      _ref36$size = _ref36.size,
      size = _ref36$size === void 0 ? 16 : _ref36$size,
      rest = _objectWithoutProperties(_ref36, _excluded36);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M21 23H17V9h4a4.0045 4.0045 0 014 4v6A4.0042 4.0042 0 0121 23zm-2-2h2a2.0023 2.0023 0 002-2V13a2.002 2.002 0 00-2-2H19zM7 11L10 11 10 23 12 23 12 11 15 11 15 9 7 9 7 11z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DeploymentUnitTechnicalData.propTypes = iconPropTypes;
}
var DeploymentUnitTechnicalExecution = /*#__PURE__*/React.forwardRef(function DeploymentUnitTechnicalExecution(_ref37, ref) {
  var children = _ref37.children,
      _ref37$size = _ref37.size,
      size = _ref37$size === void 0 ? 16 : _ref37$size,
      rest = _objectWithoutProperties(_ref37, _excluded37);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M25 11L25 9 17 9 17 23 25 23 25 21 19 21 19 17 24 17 24 15 19 15 19 11 25 11zM7 11L10 11 10 23 12 23 12 11 15 11 15 9 7 9 7 11z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DeploymentUnitTechnicalExecution.propTypes = iconPropTypes;
}
var DeploymentUnitTechnicalInstallation = /*#__PURE__*/React.forwardRef(function DeploymentUnitTechnicalInstallation(_ref38, ref) {
  var children = _ref38.children,
      _ref38$size = _ref38.size,
      size = _ref38$size === void 0 ? 16 : _ref38$size,
      rest = _objectWithoutProperties(_ref38, _excluded38);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M17 11L20 11 20 21 17 21 17 23 25 23 25 21 22 21 22 11 25 11 25 9 17 9 17 11zM7 11L10 11 10 23 12 23 12 11 15 11 15 9 7 9 7 11z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DeploymentUnitTechnicalInstallation.propTypes = iconPropTypes;
}
var DeploymentUnitTechnicalPresentation = /*#__PURE__*/React.forwardRef(function DeploymentUnitTechnicalPresentation(_ref39, ref) {
  var children = _ref39.children,
      _ref39$size = _ref39.size,
      size = _ref39$size === void 0 ? 16 : _ref39$size,
      rest = _objectWithoutProperties(_ref39, _excluded39);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M19 23H17V9h6a2.002 2.002 0 012 2v5a2.002 2.002 0 01-2 2H19zm0-7h4V10.9985H19zM7 11L10 11 10 23 12 23 12 11 15 11 15 9 7 9 7 11z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DeploymentUnitTechnicalPresentation.propTypes = iconPropTypes;
}
var DeskAdjustable = /*#__PURE__*/React.forwardRef(function DeskAdjustable(_ref40, ref) {
  var children = _ref40.children,
      _ref40$size = _ref40.size,
      size = _ref40$size === void 0 ? 16 : _ref40$size,
      rest = _objectWithoutProperties(_ref40, _excluded40);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M17 27.172L17 22 15 22 15 27.172 12.414 24.586 11 26 16 31 21 26 19.586 24.586 17 27.172z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M30 12H2v8H4V30H6V20H26V30h2V20h2zm-2 6H4V14H28zM15 4.828L15 10 17 10 17 4.828 19.586 7.414 21 6 16 1 11 6 12.414 7.414 15 4.828z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DeskAdjustable.propTypes = iconPropTypes;
}
var Development = /*#__PURE__*/React.forwardRef(function Development(_ref41, ref) {
  var children = _ref41.children,
      _ref41$size = _ref41.size,
      size = _ref41$size === void 0 ? 16 : _ref41$size,
      rest = _objectWithoutProperties(_ref41, _excluded41);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M8 4V8H4V4H8M2 2v8h8V2zM18 7v4H14V7h4M12 5v8h8V5zM8 16v4H4V16H8M2 14v8h8V14z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M22,10v6H16v6H10v8H30V10Zm-4,8h4v4H18ZM16,28H12V24h4Zm6,0H18V24h4Zm6,0H24V24h4Zm0-6H24V18h4Zm-4-6V12h4v4Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Development.propTypes = iconPropTypes;
}
var Devices = /*#__PURE__*/React.forwardRef(function Devices(_ref42, ref) {
  var children = _ref42.children,
      _ref42$size = _ref42.size,
      size = _ref42$size === void 0 ? 16 : _ref42$size,
      rest = _objectWithoutProperties(_ref42, _excluded42);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M10,30H4a2,2,0,0,1-2-2V16a2,2,0,0,1,2-2h6a2,2,0,0,1,2,2V28A2,2,0,0,1,10,30ZM4,16V28h6V16Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H6A2,2,0,0,0,4,6v6H6V6H28V20H14v2h2v4H14v2h9V26H18V22H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Devices.propTypes = iconPropTypes;
}
var DewPoint = /*#__PURE__*/React.forwardRef(function DewPoint(_ref43, ref) {
  var children = _ref43.children,
      _ref43$size = _ref43.size,
      size = _ref43$size === void 0 ? 16 : _ref43$size,
      rest = _objectWithoutProperties(_ref43, _excluded43);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M24 10a4 4 0 114-4A4.0045 4.0045 0 0124 10zm0-6a2 2 0 102 2A2.0021 2.0021 0 0024 4zM14.5 30A5.4962 5.4962 0 019 24.52c0-3.4426 4.3442-21.0141 4.5293-21.76a1 1 0 011.9414 0C15.6558 3.5059 20 21.0774 20 24.52A5.4962 5.4962 0 0114.5 30zm0-22.7561C13.0391 13.38 11 22.4089 11 24.52a3.5 3.5 0 007 0C18 22.4089 15.9609 13.38 14.5 7.2439z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DewPoint.propTypes = iconPropTypes;
}
var DewPointFilled = /*#__PURE__*/React.forwardRef(function DewPointFilled(_ref44, ref) {
  var children = _ref44.children,
      _ref44$size = _ref44.size,
      size = _ref44$size === void 0 ? 16 : _ref44$size,
      rest = _objectWithoutProperties(_ref44, _excluded44);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M24 10a4 4 0 114-4A4.0045 4.0045 0 0124 10zm0-6a2 2 0 102 2A2.0021 2.0021 0 0024 4zM14.5 30A5.4962 5.4962 0 019 24.52c0-3.4426 4.3442-21.0141 4.5293-21.76a1 1 0 011.9414 0C15.6558 3.5059 20 21.0774 20 24.52A5.4962 5.4962 0 0114.5 30z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DewPointFilled.propTypes = iconPropTypes;
}
var Diagram = /*#__PURE__*/React.forwardRef(function Diagram(_ref45, ref) {
  var children = _ref45.children,
      _ref45$size = _ref45.size,
      size = _ref45$size === void 0 ? 16 : _ref45$size,
      rest = _objectWithoutProperties(_ref45, _excluded45);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M13,30A11,11,0,0,1,13,8a1,1,0,0,1,1,1v9h9a1,1,0,0,1,1,1A11,11,0,0,1,13,30ZM12,10.06A9,9,0,1,0,21.94,20H14a2,2,0,0,1-2-2Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M28,14H19a2,2,0,0,1-2-2V3a1,1,0,0,1,1-1A11,11,0,0,1,29,13,1,1,0,0,1,28,14Zm-9-2h7.94A9,9,0,0,0,19,4.06Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Diagram.propTypes = iconPropTypes;
}
var DiagramReference = /*#__PURE__*/React.forwardRef(function DiagramReference(_ref46, ref) {
  var children = _ref46.children,
      _ref46$size = _ref46.size,
      size = _ref46$size === void 0 ? 16 : _ref46$size,
      rest = _objectWithoutProperties(_ref46, _excluded46);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M15,28V26a9.0133,9.0133,0,0,0,8.9448-8H16a2.0021,2.0021,0,0,1-2-2V8.0552A9.0133,9.0133,0,0,0,6,17H4A11.0125,11.0125,0,0,1,15,6a1,1,0,0,1,1,1v9h9a1,1,0,0,1,1,1A11.0125,11.0125,0,0,1,15,28Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0057,14H19.995A1.9957,1.9957,0,0,1,18,12V3a1.0083,1.0083,0,0,1,1.02-1A11.0125,11.0125,0,0,1,30,12.98,1.0035,1.0035,0,0,1,29.0057,14ZM20,12h7.9448A9.018,9.018,0,0,0,20,4.0552Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DiagramReference.propTypes = iconPropTypes;
}
var WatsonHealthDicom_6000 = /*#__PURE__*/React.forwardRef(function WatsonHealthDicom_6000(_ref47, ref) {
  var children = _ref47.children,
      _ref47$size = _ref47.size,
      size = _ref47$size === void 0 ? 16 : _ref47$size,
      rest = _objectWithoutProperties(_ref47, _excluded47);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M13 11H7a3 3 0 00-3 3v2H6V14a1 1 0 011-1h6a1 1 0 011 1v2h2V14A3 3 0 0013 11zM10 10A4 4 0 106 6 4 4 0 0010 10zm0-6A2 2 0 118 6 2 2 0 0110 4zM20 4H30V6H20zM20 8H30V10H20zM20 12H26V14H20zM5 30H3a2 2 0 01-2-2V22a2 2 0 012-2H6v2H3v2H5a2 2 0 012 2v2A2 2 0 015 30zM3 26v2H5V26zM13 30H11a2 2 0 01-2-2V22a2 2 0 012-2h2a2 2 0 012 2v6A2 2 0 0113 30zm-2-8v6h2V22zM21 30H19a2 2 0 01-2-2V22a2 2 0 012-2h2a2 2 0 012 2v6A2 2 0 0121 30zm-2-8v6h2V22zM29 30H27a2 2 0 01-2-2V22a2 2 0 012-2h2a2 2 0 012 2v6A2 2 0 0129 30zm-2-8v6h2V22z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  WatsonHealthDicom_6000.propTypes = iconPropTypes;
}
var WatsonHealthDicomOverlay = /*#__PURE__*/React.forwardRef(function WatsonHealthDicomOverlay(_ref48, ref) {
  var children = _ref48.children,
      _ref48$size = _ref48.size,
      size = _ref48$size === void 0 ? 16 : _ref48$size,
      rest = _objectWithoutProperties(_ref48, _excluded48);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6V26H4V6H28m0-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M6 8H16V10H6zM6 12H16V14H6zM6 16H12V18H6z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  WatsonHealthDicomOverlay.propTypes = iconPropTypes;
}
var DirectLink = /*#__PURE__*/React.forwardRef(function DirectLink(_ref49, ref) {
  var children = _ref49.children,
      _ref49$size = _ref49.size,
      size = _ref49$size === void 0 ? 16 : _ref49$size,
      rest = _objectWithoutProperties(_ref49, _excluded49);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4131,14.584,12.416,6.5869a2.0016,2.0016,0,0,0-2.832,0L1.5869,14.584a2.0016,2.0016,0,0,0,0,2.832l3.2915,3.2915L3,22.5859,4.4141,24l1.8784-1.8784L9.584,25.4131a2.0016,2.0016,0,0,0,2.832,0l2.2559-2.2559-1.4156-1.4155L10.998,23.999,3.001,16.002l7.997-8.001,8.001,8.001L17.5,17.5l1.4146,1.4146,1.4985-1.4986a2.0016,2.0016,0,0,0,0-2.832Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4131,14.584l-3.2915-3.2915L29,9.4141,27.5859,8,25.7075,9.8784,22.416,6.5869a2.0016,2.0016,0,0,0-2.832,0L17.3281,8.8428l1.4146,1.4145L20.998,8.001l8.001,8.001-8.001,7.997-7.997-7.997,1.5-1.501-1.4156-1.4156L11.5869,14.584a2.0016,2.0016,0,0,0,0,2.832l7.9971,7.9971a2.0016,2.0016,0,0,0,2.832,0l7.9971-7.9971a2.0016,2.0016,0,0,0,0-2.832Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DirectLink.propTypes = iconPropTypes;
}
var DirectionBearRight_01 = /*#__PURE__*/React.forwardRef(function DirectionBearRight_01(_ref50, ref) {
  var children = _ref50.children,
      _ref50$size = _ref50.size,
      size = _ref50$size === void 0 ? 16 : _ref50$size,
      rest = _objectWithoutProperties(_ref50, _excluded50);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M12,4V6h6.5859L12.05,12.5356a6.954,6.954,0,0,0-2.05,4.95V28h2V17.4854A4.9683,4.9683,0,0,1,13.4644,13.95L20,7.4141V14h2V4Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DirectionBearRight_01.propTypes = iconPropTypes;
}
var DirectionBearRight_01Filled = /*#__PURE__*/React.forwardRef(function DirectionBearRight_01Filled(_ref51, ref) {
  var children = _ref51.children,
      _ref51$size = _ref51.size,
      size = _ref51$size === void 0 ? 16 : _ref51$size,
      rest = _objectWithoutProperties(_ref51, _excluded51);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM22,16H20V9.4141L13.4644,15.95A4.9683,4.9683,0,0,0,12,19.4854V26H10V19.4854a6.954,6.954,0,0,1,2.05-4.95L18.5859,8H12V6H22Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M22,16H20V9.4141L13.4644,15.95A4.9683,4.9683,0,0,0,12,19.4854V26H10V19.4854a6.954,6.954,0,0,1,2.05-4.95L18.5859,8H12V6H22Z",
    "data-icon-path": "inner-path"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DirectionBearRight_01Filled.propTypes = iconPropTypes;
}
var DirectionBearRight_02 = /*#__PURE__*/React.forwardRef(function DirectionBearRight_02(_ref52, ref) {
  var children = _ref52.children,
      _ref52$size = _ref52.size,
      size = _ref52$size === void 0 ? 16 : _ref52$size,
      rest = _objectWithoutProperties(_ref52, _excluded52);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M16,4V6h6.5859L16.05,12.5356a6.954,6.954,0,0,0-2.05,4.95V28h2V17.4854A4.9683,4.9683,0,0,1,17.4644,13.95L24,7.4141V14h2V4Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 5.55H10.5V13.45H8.5z",
    transform: "rotate(-45 9.5 9.5)"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DirectionBearRight_02.propTypes = iconPropTypes;
}
var DirectionBearRight_02Filled = /*#__PURE__*/React.forwardRef(function DirectionBearRight_02Filled(_ref53, ref) {
  var children = _ref53.children,
      _ref53$size = _ref53.size,
      size = _ref53$size === void 0 ? 16 : _ref53$size,
      rest = _objectWithoutProperties(_ref53, _excluded53);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM6,7.4141,7.4141,6,14,12.5859,12.5859,14ZM26,16H24V9.4141L17.4644,15.95A4.9683,4.9683,0,0,0,16,19.4854V26H14V19.4854a6.954,6.954,0,0,1,2.05-4.95L22.5859,8H16V6H26Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M26,6V16H24V9.4141L17.4644,15.95A4.9683,4.9683,0,0,0,16,19.4854V26H14V19.4854a6.954,6.954,0,0,1,2.05-4.95L22.5859,8H16V6ZM14,12.5859,7.4141,6,6,7.4141,12.5859,14Z",
    "data-icon-path": "inner-path"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DirectionBearRight_02Filled.propTypes = iconPropTypes;
}
var DirectionCurve = /*#__PURE__*/React.forwardRef(function DirectionCurve(_ref54, ref) {
  var children = _ref54.children,
      _ref54$size = _ref54.size,
      size = _ref54$size === void 0 ? 16 : _ref54$size,
      rest = _objectWithoutProperties(_ref54, _excluded54);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M17,4l-7,7,1.4141,1.4141L16,7.8281v6.7686a3.01,3.01,0,0,1-.6572,1.874l-2.2471,2.8086A5.0206,5.0206,0,0,0,12,22.4033V28h2V22.4033a3.01,3.01,0,0,1,.6572-1.874l2.2471-2.8086A5.0206,5.0206,0,0,0,18,14.5967V7.8281l4.5859,4.586L24,11Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DirectionCurve.propTypes = iconPropTypes;
}
var DirectionCurveFilled = /*#__PURE__*/React.forwardRef(function DirectionCurveFilled(_ref55, ref) {
  var children = _ref55.children,
      _ref55$size = _ref55.size,
      size = _ref55$size === void 0 ? 16 : _ref55$size,
      rest = _objectWithoutProperties(_ref55, _excluded55);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM22.5859,13.4141,18,8.8281v5.7686a5.0206,5.0206,0,0,1-1.0957,3.124l-2.2471,2.8086A3.01,3.01,0,0,0,14,22.4033V27H12V22.4033a5.0206,5.0206,0,0,1,1.0957-3.124l2.2471-2.8086A3.01,3.01,0,0,0,16,14.5967V8.8281l-4.5859,4.586L10,12l7-7,7,7Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M22.5859,13.4141,18,8.8281v5.7686a5.0206,5.0206,0,0,1-1.0957,3.124l-2.2471,2.8086A3.01,3.01,0,0,0,14,22.4033V27H12V22.4033a5.0206,5.0206,0,0,1,1.0957-3.124l2.2471-2.8086A3.01,3.01,0,0,0,16,14.5967V8.8281l-4.5859,4.586L10,12l7-7,7,7Z",
    "data-icon-path": "inner-path"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DirectionCurveFilled.propTypes = iconPropTypes;
}
var DirectionFork = /*#__PURE__*/React.forwardRef(function DirectionFork(_ref56, ref) {
  var children = _ref56.children,
      _ref56$size = _ref56.size,
      size = _ref56$size === void 0 ? 16 : _ref56$size,
      rest = _objectWithoutProperties(_ref56, _excluded56);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M6 13L6 7.414 15 16.414 15 28 17 28 17 16.414 26 7.414 26 13 28 13 28 4 19 4 19 6 24.586 6 16 14.586 7.414 6 13 6 13 4 4 4 4 13 6 13z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DirectionFork.propTypes = iconPropTypes;
}
var DirectionForkFilled = /*#__PURE__*/React.forwardRef(function DirectionForkFilled(_ref57, ref) {
  var children = _ref57.children,
      _ref57$size = _ref57.size,
      size = _ref57$size === void 0 ? 16 : _ref57$size,
      rest = _objectWithoutProperties(_ref57, _excluded57);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M8 14L8 9.414 15 16.414 15 26 17 26 17 16.414 24 9.414 24 14 26 14 26 6 18 6 18 8 22.586 8 16 14.586 9.414 8 14 8 14 6 6 6 6 14 8 14z",
    "data-icon-path": "inner-path"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM26,14H24V9.4141l-7,7V26H15V16.4141l-7-7V14H6V6h8V8H9.4141L16,14.5859,22.5859,8H18V6h8Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DirectionForkFilled.propTypes = iconPropTypes;
}
var DirectionLoopLeft = /*#__PURE__*/React.forwardRef(function DirectionLoopLeft(_ref58, ref) {
  var children = _ref58.children,
      _ref58$size = _ref58.size,
      size = _ref58$size === void 0 ? 16 : _ref58$size,
      rest = _objectWithoutProperties(_ref58, _excluded58);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M16 20H18V28H16z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M23,4a7.0078,7.0078,0,0,0-7,7v3h2V11a5,5,0,1,1,5,5H5.8281l4.586-4.5859L9,10,2,17l7,7,1.4141-1.4141L5.8281,18H23A7,7,0,0,0,23,4Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DirectionLoopLeft.propTypes = iconPropTypes;
}
var DirectionLoopLeftFilled = /*#__PURE__*/React.forwardRef(function DirectionLoopLeftFilled(_ref59, ref) {
  var children = _ref59.children,
      _ref59$size = _ref59.size,
      size = _ref59$size === void 0 ? 16 : _ref59$size,
      rest = _objectWithoutProperties(_ref59, _excluded59);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M16,18h2v8H16ZM4,15l7,7,1.4141-1.4141L7.8281,16H21a5,5,0,1,0-5-5v1h2V11a3,3,0,1,1,3,3H7.8281l4.586-4.5859L11,8Z",
    "data-icon-path": "inner-path"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4ZM16,18h2v8H16ZM4,15l7-7,1.4141,1.4141L7.8281,14H21a3,3,0,1,0-3-3v1H16V11a5,5,0,1,1,5,5H7.8281l4.586,4.5859L11,22Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DirectionLoopLeftFilled.propTypes = iconPropTypes;
}
var DirectionLoopRight = /*#__PURE__*/React.forwardRef(function DirectionLoopRight(_ref60, ref) {
  var children = _ref60.children,
      _ref60$size = _ref60.size,
      size = _ref60$size === void 0 ? 16 : _ref60$size,
      rest = _objectWithoutProperties(_ref60, _excluded60);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M14 20H16V28H14z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M9,4a7.0078,7.0078,0,0,1,7,7v3H14V11a5,5,0,1,0-5,5H26.1719l-4.586-4.5859L23,10l7,7-7,7-1.4141-1.4141L26.1719,18H9A7,7,0,0,1,9,4Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DirectionLoopRight.propTypes = iconPropTypes;
}
var DirectionLoopRightFilled = /*#__PURE__*/React.forwardRef(function DirectionLoopRightFilled(_ref61, ref) {
  var children = _ref61.children,
      _ref61$size = _ref61.size,
      size = _ref61$size === void 0 ? 16 : _ref61$size,
      rest = _objectWithoutProperties(_ref61, _excluded61);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M16,26H14V18h2ZM21,8,19.5859,9.4141,24.1719,14H11a3,3,0,1,1,3-3v1h2V11a5,5,0,1,0-5,5H24.1719l-4.586,4.5859L21,22l7-7Z",
    "data-icon-path": "inner-path"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM16,26H14V18h2Zm5-4-1.4141-1.4141L24.1719,16H11a5,5,0,1,1,5-5v1H14V11a3,3,0,1,0-3,3H24.1719l-4.586-4.5859L21,8l7,7Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DirectionLoopRightFilled.propTypes = iconPropTypes;
}
var DirectionMerge = /*#__PURE__*/React.forwardRef(function DirectionMerge(_ref62, ref) {
  var children = _ref62.children,
      _ref62$size = _ref62.size,
      size = _ref62$size === void 0 ? 16 : _ref62$size,
      rest = _objectWithoutProperties(_ref62, _excluded62);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8784,15.4648A2.9821,2.9821,0,0,1,17,13.3433V7.8281l4.5859,4.586L23,11,16,4,9,11l1.4141,1.4141L15,7.8281v5.5152a2.9805,2.9805,0,0,1-.8784,2.1211l-2.6572,2.6567A4.9682,4.9682,0,0,0,10,21.6567V28h2V21.6567a2.9805,2.9805,0,0,1,.8784-2.1211l2.6572-2.6567A5.0021,5.0021,0,0,0,16,16.3135a5.0021,5.0021,0,0,0,.4644.5654l2.6572,2.6563A2.9821,2.9821,0,0,1,20,21.6567V28h2V21.6567a4.9682,4.9682,0,0,0-1.4644-3.5356Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DirectionMerge.propTypes = iconPropTypes;
}
var DirectionMergeFilled = /*#__PURE__*/React.forwardRef(function DirectionMergeFilled(_ref63, ref) {
  var children = _ref63.children,
      _ref63$size = _ref63.size,
      size = _ref63$size === void 0 ? 16 : _ref63$size,
      rest = _objectWithoutProperties(_ref63, _excluded63);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM17.8784,15.4648l2.6572,2.6563A4.9682,4.9682,0,0,1,22,21.6567V26H20V21.6567a2.9821,2.9821,0,0,0-.8784-2.1215l-2.6572-2.6563A5.0021,5.0021,0,0,1,16,16.3135a5.0021,5.0021,0,0,1-.4644.5654l-2.6572,2.6567A2.9805,2.9805,0,0,0,12,21.6567V26H10V21.6567a4.9682,4.9682,0,0,1,1.4644-3.5356l2.6572-2.6567A2.9805,2.9805,0,0,0,15,13.3433V8.8281l-4.5859,4.586L9,12l7-7,7,7-1.4141,1.4141L17,8.8281v4.5152A2.9821,2.9821,0,0,0,17.8784,15.4648Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M17.8784,15.4648l2.6572,2.6563A4.9682,4.9682,0,0,1,22,21.6567V26H20V21.6567a2.9821,2.9821,0,0,0-.8784-2.1215l-2.6572-2.6563A5.0021,5.0021,0,0,1,16,16.3135a5.0021,5.0021,0,0,1-.4644.5654l-2.6572,2.6567A2.9805,2.9805,0,0,0,12,21.6567V26H10V21.6567a4.9682,4.9682,0,0,1,1.4644-3.5356l2.6572-2.6567A2.9805,2.9805,0,0,0,15,13.3433V8.8281l-4.5859,4.586L9,12l7-7,7,7-1.4141,1.4141L17,8.8281v4.5152A2.9821,2.9821,0,0,0,17.8784,15.4648Z",
    "data-icon-path": "inner-path"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DirectionMergeFilled.propTypes = iconPropTypes;
}
var DirectionRight_01 = /*#__PURE__*/React.forwardRef(function DirectionRight_01(_ref64, ref) {
  var children = _ref64.children,
      _ref64$size = _ref64.size,
      size = _ref64$size === void 0 ? 16 : _ref64$size,
      rest = _objectWithoutProperties(_ref64, _excluded64);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M19,4,17.5859,5.4141,22.1719,10H10a2,2,0,0,0-2,2V28h2V12H22.1719l-4.586,4.5859L19,18l7-7Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DirectionRight_01.propTypes = iconPropTypes;
}
var DirectionRight_01Filled = /*#__PURE__*/React.forwardRef(function DirectionRight_01Filled(_ref65, ref) {
  var children = _ref65.children,
      _ref65$size = _ref65.size,
      size = _ref65$size === void 0 ? 16 : _ref65$size,
      rest = _objectWithoutProperties(_ref65, _excluded65);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM19,18l-1.4141-1.4141L22.1719,12H10V26H8V12a2,2,0,0,1,2-2H22.1719l-4.586-4.5859L19,4l7,7Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M19,18l-1.4141-1.4141L22.1719,12H10V26H8V12a2,2,0,0,1,2-2H22.1719l-4.586-4.5859L19,4l7,7Z",
    "data-icon-path": "inner-path"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DirectionRight_01Filled.propTypes = iconPropTypes;
}
var DirectionRight_02 = /*#__PURE__*/React.forwardRef(function DirectionRight_02(_ref66, ref) {
  var children = _ref66.children,
      _ref66$size = _ref66.size,
      size = _ref66$size === void 0 ? 16 : _ref66$size,
      rest = _objectWithoutProperties(_ref66, _excluded66);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M19 8L17.5859 9.4141 22.1719 14H10a2 2 0 00-2 2V28h2V16H22.1719l-4.586 4.5859L19 22l7-7zM8 4H10V12H8z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DirectionRight_02.propTypes = iconPropTypes;
}
var DirectionRight_02Filled = /*#__PURE__*/React.forwardRef(function DirectionRight_02Filled(_ref67, ref) {
  var children = _ref67.children,
      _ref67$size = _ref67.size,
      size = _ref67$size === void 0 ? 16 : _ref67$size,
      rest = _objectWithoutProperties(_ref67, _excluded67);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM8,6h2v8H8ZM19,24l-1.4141-1.4141L22.1719,18H10v8H8V18a2,2,0,0,1,2-2H22.1719l-4.586-4.5859L19,10l7,7Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M8,6h2v8H8ZM19,24l-1.4141-1.4141L22.1719,18H10v8H8V18a2,2,0,0,1,2-2H22.1719l-4.586-4.5859L19,10l7,7Z",
    "data-icon-path": "inner-path"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DirectionRight_02Filled.propTypes = iconPropTypes;
}
var DirectionRotaryFirstRight = /*#__PURE__*/React.forwardRef(function DirectionRotaryFirstRight(_ref68, ref) {
  var children = _ref68.children,
      _ref68$size = _ref68.size,
      size = _ref68$size === void 0 ? 16 : _ref68$size,
      rest = _objectWithoutProperties(_ref68, _excluded68);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M26,18v6.5859L15.8712,14.457A5.9242,5.9242,0,0,0,17,11a6,6,0,1,0-7,5.91V28h2V16.91a5.9566,5.9566,0,0,0,2.4554-1.04L24.5859,26H18v2H28V18ZM11,15a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,11,15Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DirectionRotaryFirstRight.propTypes = iconPropTypes;
}
var DirectionRotaryFirstRightFilled = /*#__PURE__*/React.forwardRef(function DirectionRotaryFirstRightFilled(_ref69, ref) {
  var children = _ref69.children,
      _ref69$size = _ref69.size,
      size = _ref69$size === void 0 ? 16 : _ref69$size,
      rest = _objectWithoutProperties(_ref69, _excluded69);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "11",
    r: "3"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM26,26H16V24h6.5859l-8.833-8.833A4.9678,4.9678,0,0,1,12,15.8989V26H10V15.8989a5.0113,5.0113,0,1,1,5.167-2.146L24,22.5859V16h2Z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M11,14a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,11,14Zm13,2v6.5859l-8.833-8.833A4.9959,4.9959,0,1,0,10,15.8989V26h2V15.8989a4.9678,4.9678,0,0,0,1.7529-.7319L22.5859,24H16v2H26V16Z",
    "data-icon-path": "inner-path"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DirectionRotaryFirstRightFilled.propTypes = iconPropTypes;
}
var DirectionRotaryRight = /*#__PURE__*/React.forwardRef(function DirectionRotaryRight(_ref70, ref) {
  var children = _ref70.children,
      _ref70$size = _ref70.size,
      size = _ref70$size === void 0 ? 16 : _ref70$size,
      rest = _objectWithoutProperties(_ref70, _excluded70);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M22,4,20.5859,5.4141,25.1719,10H16.91A5.9965,5.9965,0,1,0,10,16.91V28h2V16.91A6.0061,6.0061,0,0,0,16.91,12h8.2622l-4.586,4.5859L22,18l7-7ZM11,15a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,11,15Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DirectionRotaryRight.propTypes = iconPropTypes;
}
var DirectionRotaryRightFilled = /*#__PURE__*/React.forwardRef(function DirectionRotaryRightFilled(_ref71, ref) {
  var children = _ref71.children,
      _ref71$size = _ref71.size,
      size = _ref71$size === void 0 ? 16 : _ref71$size,
      rest = _objectWithoutProperties(_ref71, _excluded71);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "11",
    r: "3"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM20,18l-1.4141-1.4141L23.1719,12h-7.273A5.0145,5.0145,0,0,1,12,15.8989V26H10V15.8989A5,5,0,1,1,15.8989,10h7.273l-4.586-4.5859L20,4l7,7Z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M20,4,18.5859,5.4141,23.1719,10h-7.273A5,5,0,1,0,10,15.8989V26h2V15.8989A5.0145,5.0145,0,0,0,15.8989,12h7.273l-4.586,4.5859L20,18l7-7ZM11,14a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,11,14Z",
    "data-icon-path": "inner-path"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DirectionRotaryRightFilled.propTypes = iconPropTypes;
}
var DirectionRotaryStraight = /*#__PURE__*/React.forwardRef(function DirectionRotaryStraight(_ref72, ref) {
  var children = _ref72.children,
      _ref72$size = _ref72.size,
      size = _ref72$size === void 0 ? 16 : _ref72$size,
      rest = _objectWithoutProperties(_ref72, _excluded72);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M17,12.09V5.8281l4.5859,4.586L23,9,16,2,9,9l1.4141,1.4141L15,5.8281V12.09A5.9925,5.9925,0,0,0,15,23.91V28h2V23.91A5.9925,5.9925,0,0,0,17,12.09ZM16,22a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,22Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DirectionRotaryStraight.propTypes = iconPropTypes;
}
var DirectionRotaryStraightFilled = /*#__PURE__*/React.forwardRef(function DirectionRotaryStraightFilled(_ref73, ref) {
  var children = _ref73.children,
      _ref73$size = _ref73.size,
      size = _ref73$size === void 0 ? 16 : _ref73$size,
      rest = _objectWithoutProperties(_ref73, _excluded73);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "19",
    r: "3"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM21.5859,12.4141,17,7.8281v6.273a5,5,0,0,1,0,9.7978V28H15V23.8989a5,5,0,0,1,0-9.7978V7.8281l-4.5859,4.586L9,11l7-7,7,7Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M21.5859,12.4141,23,11,16,4,9,11l1.4141,1.4141L15,7.8281v6.273a5,5,0,0,0,0,9.7978V28h2V23.8989a5,5,0,0,0,0-9.7978V7.8281ZM19,19a3,3,0,1,1-3-3A3.0033,3.0033,0,0,1,19,19Z",
    "data-icon-path": "inner-path"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DirectionRotaryStraightFilled.propTypes = iconPropTypes;
}
var DirectionSharpTurn = /*#__PURE__*/React.forwardRef(function DirectionSharpTurn(_ref74, ref) {
  var children = _ref74.children,
      _ref74$size = _ref74.size,
      size = _ref74$size === void 0 ? 16 : _ref74$size,
      rest = _objectWithoutProperties(_ref74, _excluded74);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M26,18v6.5859L7.707,6.293A1,1,0,0,0,6,7V28H8V9.4141L24.5859,26H18v2H28V18Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DirectionSharpTurn.propTypes = iconPropTypes;
}
var DirectionSharpTurnFilled = /*#__PURE__*/React.forwardRef(function DirectionSharpTurnFilled(_ref75, ref) {
  var children = _ref75.children,
      _ref75$size = _ref75.size,
      size = _ref75$size === void 0 ? 16 : _ref75$size,
      rest = _objectWithoutProperties(_ref75, _excluded75);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM26,26H16V24h6.5859L8,9.4141V26H6V7a1,1,0,0,1,1.707-.707L24,22.5859V16h2Z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M26,26H16V24h6.5859L8,9.4141V26H6V7a1,1,0,0,1,1.707-.707L24,22.5859V16h2Z",
    "data-icon-path": "inner-path"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DirectionSharpTurnFilled.propTypes = iconPropTypes;
}
var DirectionStraight = /*#__PURE__*/React.forwardRef(function DirectionStraight(_ref76, ref) {
  var children = _ref76.children,
      _ref76$size = _ref76.size,
      size = _ref76$size === void 0 ? 16 : _ref76$size,
      rest = _objectWithoutProperties(_ref76, _excluded76);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M16 4L9 11 10.414 12.414 15 7.828 15 28 17 28 17 7.828 21.586 12.414 23 11 16 4z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DirectionStraight.propTypes = iconPropTypes;
}
var DirectionStraightFilled = /*#__PURE__*/React.forwardRef(function DirectionStraightFilled(_ref77, ref) {
  var children = _ref77.children,
      _ref77$size = _ref77.size,
      size = _ref77$size === void 0 ? 16 : _ref77$size,
      rest = _objectWithoutProperties(_ref77, _excluded77);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM21.5859,13.4141,17,8.8281V26H15V8.8281l-4.5859,4.586L9,12l7-7,7,7Z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M21.5859,13.4141,17,8.8281V26H15V8.8281l-4.5859,4.586L9,12l7-7,7,7Z",
    "data-icon-path": "inner-path"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DirectionStraightFilled.propTypes = iconPropTypes;
}
var DirectionStraightRight = /*#__PURE__*/React.forwardRef(function DirectionStraightRight(_ref78, ref) {
  var children = _ref78.children,
      _ref78$size = _ref78.size,
      size = _ref78$size === void 0 ? 16 : _ref78$size,
      rest = _objectWithoutProperties(_ref78, _excluded78);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M28 16L21 9 19.586 10.414 24.172 15 4 15 4 17 24.172 17 19.586 21.586 21 23 28 16z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DirectionStraightRight.propTypes = iconPropTypes;
}
var DirectionStraightRightFilled = /*#__PURE__*/React.forwardRef(function DirectionStraightRightFilled(_ref79, ref) {
  var children = _ref79.children,
      _ref79$size = _ref79.size,
      size = _ref79$size === void 0 ? 16 : _ref79$size,
      rest = _objectWithoutProperties(_ref79, _excluded79);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM20,23l-1.4141-1.4141L23.1719,17H6V15H23.1719l-4.586-4.5859L20,9l7,7Z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M20,23l-1.4141-1.4141L23.1719,17H6V15H23.1719l-4.586-4.5859L20,9l7,7Z",
    "data-icon-path": "inner-path"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DirectionStraightRightFilled.propTypes = iconPropTypes;
}
var DirectionUTurn = /*#__PURE__*/React.forwardRef(function DirectionUTurn(_ref80, ref) {
  var children = _ref80.children,
      _ref80$size = _ref80.size,
      size = _ref80$size === void 0 ? 16 : _ref80$size,
      rest = _objectWithoutProperties(_ref80, _excluded80);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5859,19.5859,22,24.1719V12A8,8,0,0,0,6,12V28H8V12a6,6,0,0,1,12,0V24.1719l-4.5859-4.586L14,21l7,7,7-7Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DirectionUTurn.propTypes = iconPropTypes;
}
var DirectionUTurnFilled = /*#__PURE__*/React.forwardRef(function DirectionUTurnFilled(_ref81, ref) {
  var children = _ref81.children,
      _ref81$size = _ref81.size,
      size = _ref81$size === void 0 ? 16 : _ref81$size,
      rest = _objectWithoutProperties(_ref81, _excluded81);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M26.5859,17.5859,22,22.1719V14A8,8,0,0,0,6,14V26H8V14a6,6,0,0,1,12,0v8.1719l-4.5859-4.586L14,19l7,7,7-7Z",
    "data-icon-path": "inner-path"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V4A2,2,0,0,0,28,2ZM21,26l-7-7,1.4141-1.4141L20,22.1719V14A6,6,0,0,0,8,14V26H6V14a8,8,0,0,1,16,0v8.1719l4.5859-4.586L28,19Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DirectionUTurnFilled.propTypes = iconPropTypes;
}
var DirectoryDomain = /*#__PURE__*/React.forwardRef(function DirectoryDomain(_ref82, ref) {
  var children = _ref82.children,
      _ref82$size = _ref82.size,
      size = _ref82$size === void 0 ? 16 : _ref82$size,
      rest = _objectWithoutProperties(_ref82, _excluded82);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M28,26H18.8157A2.9959,2.9959,0,0,0,17,24.1841V19h7a2.0025,2.0025,0,0,0,2-2V4a2.0025,2.0025,0,0,0-2-2H8A2.0025,2.0025,0,0,0,6,4V17a2.0025,2.0025,0,0,0,2,2h7v5.1841A2.9959,2.9959,0,0,0,13.1843,26H4v2h9.1843a2.982,2.982,0,0,0,5.6314,0H28ZM24,12H8V9H24Zm0-8V7H8V4ZM8,14H24v3H8Zm8,14a1,1,0,1,1,1-1A1.0008,1.0008,0,0,1,16,28Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DirectoryDomain.propTypes = iconPropTypes;
}
var DistributeHorizontalCenter = /*#__PURE__*/React.forwardRef(function DistributeHorizontalCenter(_ref83, ref) {
  var children = _ref83.children,
      _ref83$size = _ref83.size,
      size = _ref83$size === void 0 ? 16 : _ref83$size,
      rest = _objectWithoutProperties(_ref83, _excluded83);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M24 10H23V2H21v8H20a2.0023 2.0023 0 00-2 2v8a2.0023 2.0023 0 002 2h1v8h2V22h1a2.0023 2.0023 0 002-2V12A2.0023 2.0023 0 0024 10zm0 10H20V12h4zM12 6H11V2H9V6H8A2.0023 2.0023 0 006 8V24a2.0023 2.0023 0 002 2H9v4h2V26h1a2.0023 2.0023 0 002-2V8A2.0023 2.0023 0 0012 6zm0 18H8V8h4z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DistributeHorizontalCenter.propTypes = iconPropTypes;
}
var DistributeHorizontalLeft = /*#__PURE__*/React.forwardRef(function DistributeHorizontalLeft(_ref84, ref) {
  var children = _ref84.children,
      _ref84$size = _ref84.size,
      size = _ref84$size === void 0 ? 16 : _ref84$size,
      rest = _objectWithoutProperties(_ref84, _excluded84);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M28 22H24a2.0021 2.0021 0 01-2-2V12a2.0021 2.0021 0 012-2h4a2.0021 2.0021 0 012 2v8A2.0021 2.0021 0 0128 22zM24 12v8h4V12zM18 2H20V30H18zM12 26H8a2.0021 2.0021 0 01-2-2V8A2.0021 2.0021 0 018 6h4a2.0021 2.0021 0 012 2V24A2.0021 2.0021 0 0112 26zM8 8V24h4V8zM2 2H4V30H2z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DistributeHorizontalLeft.propTypes = iconPropTypes;
}
var DistributeHorizontalRight = /*#__PURE__*/React.forwardRef(function DistributeHorizontalRight(_ref85, ref) {
  var children = _ref85.children,
      _ref85$size = _ref85.size,
      size = _ref85$size === void 0 ? 16 : _ref85$size,
      rest = _objectWithoutProperties(_ref85, _excluded85);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M28 2H30V30H28zM24 22H20a2.0021 2.0021 0 01-2-2V12a2.0021 2.0021 0 012-2h4a2.0021 2.0021 0 012 2v8A2.0021 2.0021 0 0124 22zM20 12h-.0015L20 20h4V12zM12 2H14V30H12zM8 26H4a2.0021 2.0021 0 01-2-2V8A2.0021 2.0021 0 014 6H8a2.0021 2.0021 0 012 2V24A2.0021 2.0021 0 018 26zM4 8H3.9985L4 24H8V8z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DistributeHorizontalRight.propTypes = iconPropTypes;
}
var DistributeVerticalBottom = /*#__PURE__*/React.forwardRef(function DistributeVerticalBottom(_ref86, ref) {
  var children = _ref86.children,
      _ref86$size = _ref86.size,
      size = _ref86$size === void 0 ? 16 : _ref86$size,
      rest = _objectWithoutProperties(_ref86, _excluded86);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M2 28H30V30H2zM24 26H8a2.0021 2.0021 0 01-2-2V20a2.0021 2.0021 0 012-2H24a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0124 26zm0-6.0012L8 20v4H24zM2 12H30V14H2zM20 10H12a2.0021 2.0021 0 01-2-2V4a2.0021 2.0021 0 012-2h8a2.0021 2.0021 0 012 2V8A2.0021 2.0021 0 0120 10zm0-6.0012L12 4V8h8z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DistributeVerticalBottom.propTypes = iconPropTypes;
}
var DistributeVerticalCenter = /*#__PURE__*/React.forwardRef(function DistributeVerticalCenter(_ref87, ref) {
  var children = _ref87.children,
      _ref87$size = _ref87.size,
      size = _ref87$size === void 0 ? 16 : _ref87$size,
      rest = _objectWithoutProperties(_ref87, _excluded87);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M30 21H26V20a2.0023 2.0023 0 00-2-2H8a2.0023 2.0023 0 00-2 2v1H2v2H6v1a2.0023 2.0023 0 002 2H24a2.0023 2.0023 0 002-2V23h4zm-6 3H8V20l16-.001zM30 9H22V8a2.0023 2.0023 0 00-2-2H12a2.0023 2.0023 0 00-2 2V9H2v2h8v1a2.0023 2.0023 0 002 2h8a2.0023 2.0023 0 002-2V11h8zM20 12H12V8l8-.001z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DistributeVerticalCenter.propTypes = iconPropTypes;
}
var DistributeVerticalTop = /*#__PURE__*/React.forwardRef(function DistributeVerticalTop(_ref88, ref) {
  var children = _ref88.children,
      _ref88$size = _ref88.size,
      size = _ref88$size === void 0 ? 16 : _ref88$size,
      rest = _objectWithoutProperties(_ref88, _excluded88);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M24 30H8a2.0021 2.0021 0 01-2-2V24a2.0021 2.0021 0 012-2H24a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0124 30zM8 24v4H24V24zM2 18H30V20H2zM20 14H12a2.0021 2.0021 0 01-2-2V8a2.0021 2.0021 0 012-2h8a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0120 14zM12 8v4h8V8zM2 2H30V4H2z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DistributeVerticalTop.propTypes = iconPropTypes;
}
var WatsonHealthDna = /*#__PURE__*/React.forwardRef(function WatsonHealthDna(_ref89, ref) {
  var children = _ref89.children,
      _ref89$size = _ref89.size,
      size = _ref89$size === void 0 ? 16 : _ref89$size,
      rest = _objectWithoutProperties(_ref89, _excluded89);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M22,2V1H20V2a7.04,7.04,0,0,1-.08,1H12.08A7.04,7.04,0,0,1,12,2V1H10V2c0,3.7549,1.9707,5.6035,4.1008,7C11.9707,10.3965,10,12.2451,10,16s1.9707,5.6035,4.1008,7C11.9707,24.3965,10,26.2451,10,30v1h2V30a7.04,7.04,0,0,1,.08-1H19.92A7.04,7.04,0,0,1,20,30v1h2V30c0-3.7549-1.9707-5.6035-4.1008-7C20.0293,21.6035,22,19.7549,22,16s-1.9707-5.6035-4.1008-7C20.0293,7.6035,22,5.7549,22,2ZM20,16a7.04,7.04,0,0,1-.08,1H12.08a6.3212,6.3212,0,0,1,0-2H19.92A7.04,7.04,0,0,1,20,16Zm-.7559,11H12.7559A8.9078,8.9078,0,0,1,16,24.17,8.9078,8.9078,0,0,1,19.2441,27ZM16,21.83A8.9078,8.9078,0,0,1,12.7559,19h6.4882A8.9078,8.9078,0,0,1,16,21.83ZM19.2441,13H12.7559A8.9078,8.9078,0,0,1,16,10.17,8.9078,8.9078,0,0,1,19.2441,13ZM16,7.83A8.9078,8.9078,0,0,1,12.7559,5h6.4882A8.9078,8.9078,0,0,1,16,7.83Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  WatsonHealthDna.propTypes = iconPropTypes;
}
var DnsServices = /*#__PURE__*/React.forwardRef(function DnsServices(_ref90, ref) {
  var children = _ref90.children,
      _ref90$size = _ref90.size,
      size = _ref90$size === void 0 ? 16 : _ref90$size,
      rest = _objectWithoutProperties(_ref90, _excluded90);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20H30V22H20zM20 24H26V26H20z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M30,17V16A13.9871,13.9871,0,1,0,19.23,29.625l-.46-1.9463A12.0419,12.0419,0,0,1,16,28c-.19,0-.375-.0186-.563-.0273A20.3044,20.3044,0,0,1,12.0259,17Zm-2.0415-2H21.9751A24.2838,24.2838,0,0,0,19.2014,4.4414,12.0228,12.0228,0,0,1,27.9585,15ZM16.563,4.0273A20.3044,20.3044,0,0,1,19.9741,15H12.0259A20.3044,20.3044,0,0,1,15.437,4.0273C15.625,4.0186,15.81,4,16,4S16.375,4.0186,16.563,4.0273Zm-3.7644.4141A24.2838,24.2838,0,0,0,10.0249,15H4.0415A12.0228,12.0228,0,0,1,12.7986,4.4414Zm0,23.1172A12.0228,12.0228,0,0,1,4.0415,17h5.9834A24.2838,24.2838,0,0,0,12.7986,27.5586Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DnsServices.propTypes = iconPropTypes;
}
var Doc = /*#__PURE__*/React.forwardRef(function Doc(_ref91, ref) {
  var children = _ref91.children,
      _ref91$size = _ref91.size,
      size = _ref91$size === void 0 ? 16 : _ref91$size,
      rest = _objectWithoutProperties(_ref91, _excluded91);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M30 23H24a2.0023 2.0023 0 01-2-2V11a2.002 2.002 0 012-2h6v2H24V21h6zM18 23H14a2.0023 2.0023 0 01-2-2V11a2.002 2.002 0 012-2h4a2.002 2.002 0 012 2V21A2.0023 2.0023 0 0118 23zM14 11V21h4V11zM6 23H2V9H6a4.0045 4.0045 0 014 4v6A4.0045 4.0045 0 016 23zM4 21H6a2.002 2.002 0 002-2V13a2.002 2.002 0 00-2-2H4z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Doc.propTypes = iconPropTypes;
}
var Document = /*#__PURE__*/React.forwardRef(function Document(_ref92, ref) {
  var children = _ref92.children,
      _ref92$size = _ref92.size,
      size = _ref92$size === void 0 ? 16 : _ref92$size,
      rest = _objectWithoutProperties(_ref92, _excluded92);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7,9.3l-7-7C18.5,2.1,18.3,2,18,2H8C6.9,2,6,2.9,6,4v24c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V10C26,9.7,25.9,9.5,25.7,9.3 z M18,4.4l5.6,5.6H18V4.4z M24,28H8V4h8v6c0,1.1,0.9,2,2,2h6V28z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M10 22H22V24H10zM10 16H22V18H10z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Document.propTypes = iconPropTypes;
}
var DocumentAdd = /*#__PURE__*/React.forwardRef(function DocumentAdd(_ref93, ref) {
  var children = _ref93.children,
      _ref93$size = _ref93.size,
      size = _ref93$size === void 0 ? 16 : _ref93$size,
      rest = _objectWithoutProperties(_ref93, _excluded93);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M30 24L26 24 26 20 24 20 24 24 20 24 20 26 24 26 24 30 26 30 26 26 30 26 30 24z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v4h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h8ZM18,4.4,23.6,10H18Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DocumentAdd.propTypes = iconPropTypes;
}
var DocumentAttachment = /*#__PURE__*/React.forwardRef(function DocumentAttachment(_ref94, ref) {
  var children = _ref94.children,
      _ref94$size = _ref94.size,
      size = _ref94$size === void 0 ? 16 : _ref94$size,
      rest = _objectWithoutProperties(_ref94, _excluded94);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M26,30H11a2.0023,2.0023,0,0,1-2-2V22h2v6H26V6H17V4h9a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30Z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M17 10H24V12H17zM16 15H24V17H16zM15 20H24V22H15zM9 19a5.0055 5.0055 0 01-5-5V3H6V14a3 3 0 006 0V5a1 1 0 00-2 0V15H8V5a3 3 0 016 0v9A5.0055 5.0055 0 019 19z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DocumentAttachment.propTypes = iconPropTypes;
}
var DocumentAudio = /*#__PURE__*/React.forwardRef(function DocumentAudio(_ref95, ref) {
  var children = _ref95.children,
      _ref95$size = _ref95.size,
      size = _ref95$size === void 0 ? 16 : _ref95$size,
      rest = _objectWithoutProperties(_ref95, _excluded95);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M29,31a.9987.9987,0,0,1-.6245-.2192L23.6494,27H20a1,1,0,0,1-1-1V21a1,1,0,0,1,1-1h3.6494l4.7261-3.7808A1,1,0,0,1,30,17V30a1,1,0,0,1-1,1Zm-8-6h3a1,1,0,0,1,.6245.2192L28,27.9194V19.0806l-3.3755,2.7A1,1,0,0,1,24,22H21Z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3l2,0V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h8ZM18,4.4,23.6,10H18Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DocumentAudio.propTypes = iconPropTypes;
}
var DocumentBlank = /*#__PURE__*/React.forwardRef(function DocumentBlank(_ref96, ref) {
  var children = _ref96.children,
      _ref96$size = _ref96.size,
      size = _ref96$size === void 0 ? 16 : _ref96$size,
      rest = _objectWithoutProperties(_ref96, _excluded96);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7,9.3l-7-7A.9078.9078,0,0,0,18,2H8A2.0059,2.0059,0,0,0,6,4V28a2.0059,2.0059,0,0,0,2,2H24a2.0059,2.0059,0,0,0,2-2V10A.9078.9078,0,0,0,25.7,9.3ZM18,4.4,23.6,10H18ZM24,28H8V4h8v6a2.0059,2.0059,0,0,0,2,2h6Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DocumentBlank.propTypes = iconPropTypes;
}
var DocumentDownload = /*#__PURE__*/React.forwardRef(function DocumentDownload(_ref97, ref) {
  var children = _ref97.children,
      _ref97$size = _ref97.size,
      size = _ref97$size === void 0 ? 16 : _ref97$size,
      rest = _objectWithoutProperties(_ref97, _excluded97);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M30 25L28.586 23.586 26 26.172 26 18 24 18 24 26.172 21.414 23.586 20 25 25 30 30 25z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M18,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3l2,0V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2H18ZM18,4.4,23.6,10H18Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DocumentDownload.propTypes = iconPropTypes;
}
var DocumentEpdf = /*#__PURE__*/React.forwardRef(function DocumentEpdf(_ref98, ref) {
  var children = _ref98.children,
      _ref98$size = _ref98.size,
      size = _ref98$size === void 0 ? 16 : _ref98$size,
      rest = _objectWithoutProperties(_ref98, _excluded98);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M28,26V22a2.0023,2.0023,0,0,0-2-2H22a2.0023,2.0023,0,0,0-2,2v6a2.0077,2.0077,0,0,0,2,2h5V28H22V26Zm-6-4h4v2H22Z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M25.707,9.293l-7-7A1,1,0,0,0,18,2H8A2.002,2.002,0,0,0,6,4V28a2.0023,2.0023,0,0,0,2,2h8V28H8V4h8v6a2.002,2.002,0,0,0,2,2h6v4h2V10A1,1,0,0,0,25.707,9.293ZM18,4.4141,23.5859,10H18Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DocumentEpdf.propTypes = iconPropTypes;
}
var DocumentExport = /*#__PURE__*/React.forwardRef(function DocumentExport(_ref99, ref) {
  var children = _ref99.children,
      _ref99$size = _ref99.size,
      size = _ref99$size === void 0 ? 16 : _ref99$size,
      rest = _objectWithoutProperties(_ref99, _excluded99);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M13 21L26.17 21 23.59 23.59 25 25 30 20 25 15 23.59 16.41 26.17 19 13 19 13 21z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M22,14V10a1,1,0,0,0-.29-.71l-7-7A1,1,0,0,0,14,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V26H20v2H4V4h8v6a2,2,0,0,0,2,2h6v2Zm-8-4V4.41L19.59,10Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DocumentExport.propTypes = iconPropTypes;
}
var DocumentHorizontal = /*#__PURE__*/React.forwardRef(function DocumentHorizontal(_ref100, ref) {
  var children = _ref100.children,
      _ref100$size = _ref100.size,
      size = _ref100$size === void 0 ? 16 : _ref100$size,
      rest = _objectWithoutProperties(_ref100, _excluded100);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6H4A2.0023,2.0023,0,0,0,2,8V24a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V8A2.0023,2.0023,0,0,0,28,6ZM20,24H12V22a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1Zm8,0H22V22a3,3,0,0,0-3-3H13a3,3,0,0,0-3,3v2H4V8H28Z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M16,18a4,4,0,1,0-4-4A4,4,0,0,0,16,18Zm0-6a2,2,0,1,1-2,2A2,2,0,0,1,16,12Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DocumentHorizontal.propTypes = iconPropTypes;
}
var DocumentImport = /*#__PURE__*/React.forwardRef(function DocumentImport(_ref101, ref) {
  var children = _ref101.children,
      _ref101$size = _ref101.size,
      size = _ref101$size === void 0 ? 16 : _ref101$size,
      rest = _objectWithoutProperties(_ref101, _excluded101);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M28 19L14.83 19 17.41 16.41 16 15 11 20 16 25 17.41 23.59 14.83 21 28 21 28 19z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M24,14V10a1,1,0,0,0-.29-.71l-7-7A1,1,0,0,0,16,2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V26H22v2H6V4h8v6a2,2,0,0,0,2,2h6v2Zm-8-4V4.41L21.59,10Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DocumentImport.propTypes = iconPropTypes;
}
var DocumentPdf = /*#__PURE__*/React.forwardRef(function DocumentPdf(_ref102, ref) {
  var children = _ref102.children,
      _ref102$size = _ref102.size,
      size = _ref102$size === void 0 ? 16 : _ref102$size,
      rest = _objectWithoutProperties(_ref102, _excluded102);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M30 18L30 16 24 16 24 26 26 26 26 22 29 22 29 20 26 20 26 18 30 18zM19 26H15V16h4a3.0033 3.0033 0 013 3v4A3.0033 3.0033 0 0119 26zm-2-2h2a1.0011 1.0011 0 001-1V19a1.0011 1.0011 0 00-1-1H17zM11 16H6V26H8V23h3a2.0027 2.0027 0 002-2V18A2.0023 2.0023 0 0011 16zM8 21V18h3l.001 3z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M22,14V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,14,2H4A2.0059,2.0059,0,0,0,2,4V28a2,2,0,0,0,2,2H20V28H4V4h8v6a2.0059,2.0059,0,0,0,2,2h6v2Zm-8-4V4.4L19.6,10Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DocumentPdf.propTypes = iconPropTypes;
}
var DocumentPreliminary = /*#__PURE__*/React.forwardRef(function DocumentPreliminary(_ref103, ref) {
  var children = _ref103.children,
      _ref103$size = _ref103.size,
      size = _ref103$size === void 0 ? 16 : _ref103$size,
      rest = _objectWithoutProperties(_ref103, _excluded103);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M24 30a6 6 0 116-6A6.0067 6.0067 0 0124 30zm0-10a4 4 0 104 4A4.0045 4.0045 0 0024 20zM8 22H16V24H8zM8 16H18V18H8z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28H6V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,16,2H6A2.0058,2.0058,0,0,0,4,4V28a2.0058,2.0058,0,0,0,2,2H16ZM16,4.4,21.6,10H16Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DocumentPreliminary.propTypes = iconPropTypes;
}
var DocumentProtected = /*#__PURE__*/React.forwardRef(function DocumentProtected(_ref104, ref) {
  var children = _ref104.children,
      _ref104$size = _ref104.size,
      size = _ref104$size === void 0 ? 16 : _ref104$size,
      rest = _objectWithoutProperties(_ref104, _excluded104);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M28,21V18a4,4,0,0,0-8,0v3a2.0025,2.0025,0,0,0-2,2v5a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V23A2.0025,2.0025,0,0,0,28,21Zm-6-3a2,2,0,0,1,4,0v3H22ZM20,28V23h8v5Z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M23.499,9.085,16.707,2.293A1,1,0,0,0,16,2H6A2.0058,2.0058,0,0,0,4,4V28a2.0058,2.0058,0,0,0,2,2h8V28H6V4h8v6a2.0023,2.0023,0,0,0,2,2h6.292a1.7075,1.7075,0,0,0,1.207-2.915ZM16,10V4.4141L21.5854,10Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DocumentProtected.propTypes = iconPropTypes;
}
var DocumentSecurity = /*#__PURE__*/React.forwardRef(function DocumentSecurity(_ref105, ref) {
  var children = _ref105.children,
      _ref105$size = _ref105.size,
      size = _ref105$size === void 0 ? 16 : _ref105$size,
      rest = _objectWithoutProperties(_ref105, _excluded105);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M23,30l-2.1387-1.0127A5.0216,5.0216,0,0,1,18,24.4678V18H28v6.4678a5.0216,5.0216,0,0,1-2.8613,4.52ZM20,20v4.4678a3.012,3.012,0,0,0,1.7168,2.7109L23,27.7861l1.2832-.6074A3.012,3.012,0,0,0,26,24.4678V20Z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28H6V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,16,2H6A2.0058,2.0058,0,0,0,4,4V28a2.0058,2.0058,0,0,0,2,2H16ZM16,4.4,21.6,10H16Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DocumentSecurity.propTypes = iconPropTypes;
}
var DocumentSigned = /*#__PURE__*/React.forwardRef(function DocumentSigned(_ref106, ref) {
  var children = _ref106.children,
      _ref106$size = _ref106.size,
      size = _ref106$size === void 0 ? 16 : _ref106$size,
      rest = _objectWithoutProperties(_ref106, _excluded106);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4141,30H15V25.5857l5.0337-5.0337A4.6069,4.6069,0,0,1,20,20a5,5,0,1,1,4.4478,4.9663ZM17,28h1.5859l5.2061-5.2063.5395.1238a3.0351,3.0351,0,1,0-2.249-2.2488l.1236.5393L17,26.4143Z"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: "25",
    cy: "20",
    r: "1"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6H20V8H8zM8 10H20V12H8zM8 14H14V16H8zM8 24H12V26H8z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M12,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2v9H22V4H6V28h6Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DocumentSigned.propTypes = iconPropTypes;
}
var DocumentSketch = /*#__PURE__*/React.forwardRef(function DocumentSketch(_ref107, ref) {
  var children = _ref107.children,
      _ref107$size = _ref107.size,
      size = _ref107$size === void 0 ? 16 : _ref107$size,
      rest = _objectWithoutProperties(_ref107, _excluded107);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M26,20l1.4272,1.9028L23,26.9629l-4.4272-5.06L20,20h6m1-2H19l-3,4,7,8,7-8-3-4Z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3l2,0V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h8ZM18,4.4,23.6,10H18Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DocumentSketch.propTypes = iconPropTypes;
}
var DocumentSubtract = /*#__PURE__*/React.forwardRef(function DocumentSubtract(_ref108, ref) {
  var children = _ref108.children,
      _ref108$size = _ref108.size,
      size = _ref108$size === void 0 ? 16 : _ref108$size,
      rest = _objectWithoutProperties(_ref108, _excluded108);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M20 24H30V26H20z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v8h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h8ZM18,4.4,23.6,10H18Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DocumentSubtract.propTypes = iconPropTypes;
}
var DocumentTasks = /*#__PURE__*/React.forwardRef(function DocumentTasks(_ref109, ref) {
  var children = _ref109.children,
      _ref109$size = _ref109.size,
      size = _ref109$size === void 0 ? 16 : _ref109$size,
      rest = _objectWithoutProperties(_ref109, _excluded109);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M22 27.18L19.41 24.59 18 26 22 30 30 22 28.59 20.59 22 27.18z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M15,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v6h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h7ZM18,4.4,23.6,10H18Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DocumentTasks.propTypes = iconPropTypes;
}
var DocumentUnknown = /*#__PURE__*/React.forwardRef(function DocumentUnknown(_ref110, ref) {
  var children = _ref110.children,
      _ref110$size = _ref110.size,
      size = _ref110$size === void 0 ? 16 : _ref110$size,
      rest = _objectWithoutProperties(_ref110, _excluded110);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "28.5",
    r: "1.5"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M10,25H8V21h2a2,2,0,0,0,0-4H8a2.0023,2.0023,0,0,0-2,2v.5H4V19a4.0045,4.0045,0,0,1,4-4h2a4,4,0,0,1,0,8Z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7,9.3l-7-7A.9085.9085,0,0,0,20,2H10A2.0058,2.0058,0,0,0,8,4v8h2V4h8v6a2.0058,2.0058,0,0,0,2,2h6V28H14v2H26a2.0058,2.0058,0,0,0,2-2V10A.9092.9092,0,0,0,27.7,9.3ZM20,10V4.4L25.6,10Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DocumentUnknown.propTypes = iconPropTypes;
}
var DocumentUnprotected = /*#__PURE__*/React.forwardRef(function DocumentUnprotected(_ref111, ref) {
  var children = _ref111.children,
      _ref111$size = _ref111.size,
      size = _ref111$size === void 0 ? 16 : _ref111$size,
      rest = _objectWithoutProperties(_ref111, _excluded111);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M23.499,9.085,16.707,2.293A1,1,0,0,0,16,2H6A2.0058,2.0058,0,0,0,4,4V28a2.0058,2.0058,0,0,0,2,2h8V28H6V4h8v6a2.0023,2.0023,0,0,0,2,2h6.292a1.7075,1.7075,0,0,0,1.207-2.915ZM16,10V4.4141L21.5854,10Z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M28,21H22V18a2,2,0,0,1,4,0h2a4,4,0,0,0-8,0v3a2.0025,2.0025,0,0,0-2,2v5a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V23A2.0025,2.0025,0,0,0,28,21Zm-8,7V23h8v5Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DocumentUnprotected.propTypes = iconPropTypes;
}
var DocumentVertical = /*#__PURE__*/React.forwardRef(function DocumentVertical(_ref112, ref) {
  var children = _ref112.children,
      _ref112$size = _ref112.size,
      size = _ref112$size === void 0 ? 16 : _ref112$size,
      rest = _objectWithoutProperties(_ref112, _excluded112);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M16,14a4,4,0,1,1,4-4h0A4.0118,4.0118,0,0,1,16,14Zm0-6a2,2,0,1,0,2,2h0a2.0059,2.0059,0,0,0-2-2Z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M24,2H8A2.0023,2.0023,0,0,0,6,4V28a2.0023,2.0023,0,0,0,2,2H24a2.0023,2.0023,0,0,0,2-2V4A2.0023,2.0023,0,0,0,24,2ZM12,24V18a.9447.9447,0,0,1,1-1h6a.9447.9447,0,0,1,1,1v6H18v4H14V24Zm8,4V26a2.0058,2.0058,0,0,0,2-2V18a2.9463,2.9463,0,0,0-3-3H13a2.9463,2.9463,0,0,0-3,3v6a2.0058,2.0058,0,0,0,2,2v2H8V4H24V28Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DocumentVertical.propTypes = iconPropTypes;
}
var DocumentVideo = /*#__PURE__*/React.forwardRef(function DocumentVideo(_ref113, ref) {
  var children = _ref113.children,
      _ref113$size = _ref113.size,
      size = _ref113$size === void 0 ? 16 : _ref113$size,
      rest = _objectWithoutProperties(_ref113, _excluded113);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M30,19l-4,3.2V20a2.0023,2.0023,0,0,0-2-2H16a2.0023,2.0023,0,0,0-2,2v6a2.0023,2.0023,0,0,0,2,2h8a2.0023,2.0023,0,0,0,2-2V23.8L30,27ZM16,26V20h8l.0015,6Z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M12,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3l2,0V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h4ZM18,4.4,23.6,10H18Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DocumentVideo.propTypes = iconPropTypes;
}
var DocumentView = /*#__PURE__*/React.forwardRef(function DocumentView(_ref114, ref) {
  var children = _ref114.children,
      _ref114$size = _ref114.size,
      size = _ref114$size === void 0 ? 16 : _ref114$size,
      rest = _objectWithoutProperties(_ref114, _excluded114);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "24",
    r: "2"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M22,28a4,4,0,1,1,4-4A4.0039,4.0039,0,0,1,22,28Zm0-6a2,2,0,1,0,2,2A2.0027,2.0027,0,0,0,22,22Z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7769,23.4785A8.64,8.64,0,0,0,22,18a8.64,8.64,0,0,0-7.7769,5.4785L14,24l.2231.5215A8.64,8.64,0,0,0,22,30a8.64,8.64,0,0,0,7.7769-5.4785L30,24ZM22,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,28Z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M12,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v4h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h4ZM18,4.4,23.6,10H18Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DocumentView.propTypes = iconPropTypes;
}
var DocumentWordProcessor = /*#__PURE__*/React.forwardRef(function DocumentWordProcessor(_ref115, ref) {
  var children = _ref115.children,
      _ref115$size = _ref115.size,
      size = _ref115$size === void 0 ? 16 : _ref115$size,
      rest = _objectWithoutProperties(_ref115, _excluded115);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3 20L27.391 28.611 26 20 24 20 22.609 28.611 21.7 20 20 20 21.36 30 23.64 30 25 21.626 26.36 30 28.64 30 30 20 28.3 20z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M25.707,9.293l-7-7A1,1,0,0,0,18,2H8A2.002,2.002,0,0,0,6,4V28a2.0023,2.0023,0,0,0,2,2h8V28H8V4h8v6a2.002,2.002,0,0,0,2,2h6v4h2V10A1,1,0,0,0,25.707,9.293ZM18,4.4141,23.5859,10H18Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DocumentWordProcessor.propTypes = iconPropTypes;
}
var DocumentWordProcessorReference = /*#__PURE__*/React.forwardRef(function DocumentWordProcessorReference(_ref116, ref) {
  var children = _ref116.children,
      _ref116$size = _ref116.size,
      size = _ref116$size === void 0 ? 16 : _ref116$size,
      rest = _objectWithoutProperties(_ref116, _excluded116);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3 20L27.391 28.611 26 20 24 20 22.609 28.611 21.7 20 20 20 21.36 30 23.64 30 25 21.626 26.36 30 28.64 30 30 20 28.3 20zM4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM25.707 9.293l-7-7A1 1 0 0018 2H8A2.002 2.002 0 006 4V16H8V4h8v6a2.002 2.002 0 002 2h6v4h2V10A1 1 0 0025.707 9.293zM18 10V4.4141L23.5859 10z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DocumentWordProcessorReference.propTypes = iconPropTypes;
}
var DocumentSentiment = /*#__PURE__*/React.forwardRef(function DocumentSentiment(_ref117, ref) {
  var children = _ref117.children,
      _ref117$size = _ref117.size,
      size = _ref117$size === void 0 ? 16 : _ref117$size,
      rest = _objectWithoutProperties(_ref117, _excluded117);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M18.303,16a2.6616,2.6616,0,0,0-1.9079.8058l-.3932.4054-.397-.4054a2.6615,2.6615,0,0,0-3.8157,0,2.7992,2.7992,0,0,0,0,3.8964L16.0019,25l4.2089-4.2978a2.7992,2.7992,0,0,0,0-3.8964A2.6616,2.6616,0,0,0,18.303,16Z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7,9.3l-7-7A.9078.9078,0,0,0,18,2H8A2.0059,2.0059,0,0,0,6,4V28a2.0059,2.0059,0,0,0,2,2H24a2.0059,2.0059,0,0,0,2-2V10A.9078.9078,0,0,0,25.7,9.3ZM18,4.4,23.6,10H18ZM24,28H8V4h8v6a2.0059,2.0059,0,0,0,2,2h6Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DocumentSentiment.propTypes = iconPropTypes;
}
var DogWalker = /*#__PURE__*/React.forwardRef(function DogWalker(_ref118, ref) {
  var children = _ref118.children,
      _ref118$size = _ref118.size,
      size = _ref118$size === void 0 ? 16 : _ref118$size,
      rest = _objectWithoutProperties(_ref118, _excluded118);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20H22V30H20zM4 23H6V30H4z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M16 30H14V26a1.0011 1.0011 0 00-1-1H11v5H9V23h4a3.0033 3.0033 0 013 3zM7.5 22A3.5041 3.5041 0 014 18.5V17H2V15H6v3.5a1.5 1.5 0 003 0V15h4v2H11v1.5A3.5041 3.5041 0 017.5 22zM27 10H21.354a2.9861 2.9861 0 00-2.7856 1.8857l-1.4419 3.6055-3.6079 4.51 1.562 1.249 3.7-4.625 1.645-3.9961A.9949.9949 0 0121.354 12H27a1.0009 1.0009 0 011 1v7H25V30h2V22h1a2.0023 2.0023 0 002-2V13A3.0033 3.0033 0 0027 10zM24 9a4 4 0 114-4A4.0045 4.0045 0 0124 9zm0-6a2 2 0 102 2A2.0021 2.0021 0 0024 3z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DogWalker.propTypes = iconPropTypes;
}
var DotMark = /*#__PURE__*/React.forwardRef(function DotMark(_ref119, ref) {
  var children = _ref119.children,
      _ref119$size = _ref119.size,
      size = _ref119$size === void 0 ? 16 : _ref119$size,
      rest = _objectWithoutProperties(_ref119, _excluded119);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "8"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DotMark.propTypes = iconPropTypes;
}
var DoubleInteger = /*#__PURE__*/React.forwardRef(function DoubleInteger(_ref120, ref) {
  var children = _ref120.children,
      _ref120$size = _ref120.size,
      size = _ref120$size === void 0 ? 16 : _ref120$size,
      rest = _objectWithoutProperties(_ref120, _excluded120);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M17 8V6H13V2H11V6H8V2H6V6H2V8H6v3H2v2H6v4H8V13h3v4h2V13h4V11H13V8zm-6 3H8V8h3zM30 21V19H26V15H24v4H21V15H19v4H15v2h4v3H15v2h4v4h2V26h3v4h2V26h4V24H26V21zm-6 3H21V21h3z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DoubleInteger.propTypes = iconPropTypes;
}
var DownToBottom = /*#__PURE__*/React.forwardRef(function DownToBottom(_ref121, ref) {
  var children = _ref121.children,
      _ref121$size = _ref121.size,
      size = _ref121$size === void 0 ? 16 : _ref121$size,
      rest = _objectWithoutProperties(_ref121, _excluded121);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M16 18L6 8 7.4 6.6 16 15.2 24.6 6.6 26 8zM4 22H28V24H4z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DownToBottom.propTypes = iconPropTypes;
}
var Download = /*#__PURE__*/React.forwardRef(function Download(_ref122, ref) {
  var children = _ref122.children,
      _ref122$size = _ref122.size,
      size = _ref122$size === void 0 ? 16 : _ref122$size,
      rest = _objectWithoutProperties(_ref122, _excluded122);

  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor"
    }, rest), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
      d: "M13 7L12.3 6.3 8.5 10.1 8.5 1 7.5 1 7.5 10.1 3.7 6.3 3 7 8 12zM13 12v2H3v-2H2v2l0 0c0 .6.4 1 1 1h10c.6 0 1-.4 1-1l0 0v-2H13z"
    })), children);
  }

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M26 24v4H6V24H4v4H4a2 2 0 002 2H26a2 2 0 002-2h0V24zM26 14L24.59 12.59 17 20.17 17 2 15 2 15 20.17 7.41 12.59 6 14 16 24 26 14z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  Download.propTypes = iconPropTypes;
}
var WatsonHealthDownloadStudy = /*#__PURE__*/React.forwardRef(function WatsonHealthDownloadStudy(_ref123, ref) {
  var children = _ref123.children,
      _ref123$size = _ref123.size,
      size = _ref123$size === void 0 ? 16 : _ref123$size,
      rest = _objectWithoutProperties(_ref123, _excluded123);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M30 25L28.586 23.586 26 26.172 26 18 24 18 24 26.172 21.414 23.586 20 25 25 30 30 25zM19 14H23V16H19zM19 10H26V12H19zM9 18h6a3 3 0 013 3v2H16V21a1 1 0 00-1-1H9a1 1 0 00-1 1v2H6V21A3 3 0 019 18zM16 13a4 4 0 10-4 4A4 4 0 0016 13zm-2 0a2 2 0 11-2-2A2 2 0 0114 13z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M18,26H4V6H28V16h2V6a2,2,0,0,0-2-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H18Z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  WatsonHealthDownloadStudy.propTypes = iconPropTypes;
}
var DragHorizontal = /*#__PURE__*/React.forwardRef(function DragHorizontal(_ref124, ref) {
  var children = _ref124.children,
      _ref124$size = _ref124.size,
      size = _ref124$size === void 0 ? 16 : _ref124$size,
      rest = _objectWithoutProperties(_ref124, _excluded124);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4L12 15 5.83 15 8.41 12.41 7 11 2 16 7 21 8.41 19.59 5.83 17 12 17 12 28 14 28 14 4 12 4zM25 11L23.59 12.41 26.17 15 20 15 20 4 18 4 18 28 20 28 20 17 26.17 17 23.59 19.59 25 21 30 16 25 11z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DragHorizontal.propTypes = iconPropTypes;
}
var DragVertical = /*#__PURE__*/React.forwardRef(function DragVertical(_ref125, ref) {
  var children = _ref125.children,
      _ref125$size = _ref125.size,
      size = _ref125$size === void 0 ? 16 : _ref125$size,
      rest = _objectWithoutProperties(_ref125, _excluded125);

  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L15 20 15 26.17 12.41 23.59 11 25 16 30 21 25 19.59 23.59 17 26.17 17 20 28 20 28 18 4 18 4 20zM11 7L12.41 8.41 15 5.83 15 12 4 12 4 14 28 14 28 12 17 12 17 5.83 19.59 8.41 21 7 16 2 11 7z"
  })), children);
});

if (process.env.NODE_ENV !== "production") {
  DragVertical.propTypes = iconPropTypes;
}

export { DataQualityDefinition, DataRefinery, DataRefineryReference, DataShare, DataTable, DataTableReference, DataVis_1, DataVis_2, DataVis_3, DataVis_4, DatabaseDatastax, DatabaseElastic, DatabaseEnterpriseDb2, DatabaseEtcd, DatabaseMongodb, DatabasePostgreSql, DatabaseRabbit, DatabaseRedis, Datastore, Debug, DecisionTree, Delivery, DeliveryAdd, DeliveryParcel, DeliveryTruck, Departure, Deploy, DeployRules, DeploymentPattern, DeploymentPolicy, DeploymentUnitData, DeploymentUnitExecution, DeploymentUnitInstallation, DeploymentUnitPresentation, DeploymentUnitTechnicalData, DeploymentUnitTechnicalExecution, DeploymentUnitTechnicalInstallation, DeploymentUnitTechnicalPresentation, DeskAdjustable, Development, Devices, DewPoint, DewPointFilled, Diagram, DiagramReference, DirectLink, DirectionBearRight_01, DirectionBearRight_01Filled, DirectionBearRight_02, DirectionBearRight_02Filled, DirectionCurve, DirectionCurveFilled, DirectionFork, DirectionForkFilled, DirectionLoopLeft, DirectionLoopLeftFilled, DirectionLoopRight, DirectionLoopRightFilled, DirectionMerge, DirectionMergeFilled, DirectionRight_01, DirectionRight_01Filled, DirectionRight_02, DirectionRight_02Filled, DirectionRotaryFirstRight, DirectionRotaryFirstRightFilled, DirectionRotaryRight, DirectionRotaryRightFilled, DirectionRotaryStraight, DirectionRotaryStraightFilled, DirectionSharpTurn, DirectionSharpTurnFilled, DirectionStraight, DirectionStraightFilled, DirectionStraightRight, DirectionStraightRightFilled, DirectionUTurn, DirectionUTurnFilled, DirectoryDomain, DistributeHorizontalCenter, DistributeHorizontalLeft, DistributeHorizontalRight, DistributeVerticalBottom, DistributeVerticalCenter, DistributeVerticalTop, DnsServices, Doc, Document, DocumentAdd, DocumentAttachment, DocumentAudio, DocumentBlank, DocumentDownload, DocumentEpdf, DocumentExport, DocumentHorizontal, DocumentImport, DocumentPdf, DocumentPreliminary, DocumentProtected, DocumentSecurity, DocumentSentiment, DocumentSigned, DocumentSketch, DocumentSubtract, DocumentTasks, DocumentUnknown, DocumentUnprotected, DocumentVertical, DocumentVideo, DocumentView, DocumentWordProcessor, DocumentWordProcessorReference, DogWalker, DotMark, DoubleInteger, DownToBottom, Download, DragHorizontal, DragVertical, WatsonHealthDenominate, WatsonHealthDicomOverlay, WatsonHealthDicom_6000, WatsonHealthDna, WatsonHealthDownloadStudy };
